module.exports = {
  // заглушка если текста нет
  ' ': ' ',
  DELETE_PARTICIPANT: '刪除參賽者',

  // Countries
  'country.AZ': '亞塞拜然',
  'country.AM': '亞美尼亞',
  'country.BY': '白俄羅斯',
  'country.BE': '比利時',
  'country.BG': '保加利亞',
  'country.GB': '英國',
  'country.DE': '德國',
  'country.IL': '以色列',
  'country.IN': '印度',
  'country.IT': '義大利',
  'country.KZ': '哈薩克',
  'country.CY': '賽普勒斯',
  'country.KG': '吉爾吉斯',
  'country.KR': '韓國',
  'country.LB': '黎巴嫩',
  'country.LT': '立陶宛',
  'country.LV': '拉脫維亞',
  'country.RU': '俄羅斯',
  'country.RO': '羅馬尼亞',
  'country.US': '美國',
  'country.SA': '沙烏地阿拉伯',
  'country.TJ': '塔吉克',
  'country.TH': '泰國',
  'country.TQ': '土耳其',
  'country.UZ': '烏茲別克',
  'country.UA': '烏克蘭',
  'country.FR': '法國',
  'country.CH': '瑞士',
  'country.SE': '瑞典',
  'country.EE': '愛沙尼亞',
  'country.CN': '中國',
  'country.TW': '台灣',
  'country.CA': '加拿大',
  'country.MY': '馬來西亞',
  'country.HK': '香港',
  'country.VN': '越南',
  'country.PS': '巴勒斯坦',
  'country.EG': '埃及',
  'country.JO': '約旦',
  'country.IQ': '伊拉克',
  'country.IR': '伊朗',
  'country.AE': '阿聯',
  'country.AU': '澳洲',
  'country.ZA': '南非',

  // Sign In
  'signin.title': '登入',
  'signin.subtitle': '請輸入您的資料',
  'signin.password_old': '目前密碼',
  'signin.password_new': '新密碼',
  'signin.password_confirm': '確認新密碼',
  'signin.btn_title': '登入',
  'signin.repeat': '註冊尚未確認。請按照電子郵件中的說明操作。{repeat}確認信件',

  // Sign Up
  'signup.title': '註冊',
  'signup.subtitle': '請輸入詳細資料',
  'signup.btn_title': '註冊',
  INVALID_TOKEN: '驗證碼無效。',
  VALIDATION_EMAIL_ALREADY_EXIST: '此電子郵件已註冊。',
  VALIDATION_EMAIL_ALREADY_USED: '此電子郵件已被使用',
  'signup.success_message':
    '確認信已發送至您提供的電子郵件地址。如果未收到，請返回註冊頁面重新輸入資料，或聯絡技術支援。',

  // Verify
  'verify.success_message': '您已成功註冊。若要登入，',
  'verify.success_message_link': '請輸入您的帳號密碼',

  // Resend
  'resend.success_message': '電子郵件已發送',

  // Logout
  'logout.title': '登出',
  'logout.success_message': '您已成功登出',

  // Forgot Password
  'forgotPassword.title': '忘記密碼？',
  'forgotPassword.subtitle': '建立新密碼以存取您的帳號',
  'forgotPassword.btn_title': '送出',
  'forgotPassword.success_message':
    '密碼重設連結已發送至您的電子郵件。如果未收到，請返回密碼重設頁面重新嘗試，或聯絡技術支援。',

  // Reset Password
  'resetPassword.title': '重設密碼',
  'resetPassword.btn_title': '重設密碼',
  'resetPassword.success_message': '您的密碼已成功重設。',

  // Change Password
  'changePassword.title': '變更密碼',
  'changePassword.btn_title': '變更',
  'changePassword.success_message': '密碼變更成功。請牢記或記下您的新密碼。',

  // Home
  'home.title': '歡迎訊息與圖片將顯示在此處',

  // Not Found
  'notFound.title': '錯誤 404',
  'notFound.subtitle': '找不到頁面',

  // Forms
  'form.email': '電子郵件',
  'form.password': '密碼',
  'form.password_old': '目前密碼',
  'form.password_new': '新密碼',
  'form.confirm_password': '確認密碼',
  'form.agree': '我同意....',
  'form.code': '驗證碼',

  // Common
  'common.repeat': '重試',
  'common.success_message': '成功',

  // Notice
  'notice.success': '成功',
  SAVED: '已儲存',

  // Validation
  MUST_BE_CONTAINS_LETTERS: '密碼必須包含至少 1 個英文字母',
  MUST_BE_CONTAINS_NUMBER: '密碼必須包含數字',
  MUST_BE_7_CHARACTERS_OR_MORE: '密碼長度至少 7 個字元',
  MUST_BE_4_CHARACTERS_OR_MORE: '密碼長度至少 4 個字元',
  MUST_BE_NUMERIC: '必須為數字',
  MUST_BE_POSITIVE: '金額必須大於 0',
  REQUIRED: '此欄位為必填',
  PASSWORD_DO_NOT_MATCH: '密碼不一致',
  INVALID_EMAIL_ADDRESS: '電子郵件格式不正確',
  UNACCEPTABLE_SIGNS: '包含無效字元或空格',
  INVALID_DATE: '日期格式必須為 DD.MM.YYYY',
  TIMETABLE_ERROR: '請設定作業排程',

  // Errors
  INVALID_LOGIN_DATA: '電子郵件或密碼不正確',
  CANNOT_FOUND_USER_WITH_THIS_EMAIL: '找不到此電子郵件的使用者',
  INVALID_OLD_PASSWORD: '目前密碼不正確',
  EMPTY_OR_VERY_SHORT_PASSWORD: '密碼未填寫或太短',

  // Stub
  simulators: '練習工具',
  stub1: '參考資料',
  reports: '統計報表',

  // Main Filter (Rule) — ментальная арифметика
  RULE_SIMPLE_SUM: '直算',
  RULE_FIVE_SUM: '滿五口訣',
  RULE_TEN_SUM: '滿十口訣',
  RULE_FIVE_AND_TEN_SUM: '滿五與滿十口訣',
  NO_MODE: '隨機',

  // Menu
  DIRECTORY: '名錄',
  ARCHIVE: '封存',

  // Student
  STUDENT_TITLE: '學生',
  STUDENT_TITLE_SINGULAR: '學生',
  STUDENT_FORM_LEFT_PATH_TITLE: '學生資料',
  STUDENT_FORM_RIGTH_PATH_TITLE: '家長資料',
  STUDENT_TABLE_CREATE_TITLE: '新增學生',
  STUDENT_TABLE_SAVE_TITLE: '編輯學生資料',
  STUDENT_TABLE_CREATE: '尚未分配教師的學生',
  STUDENT_TABLE_INVITE: '發送邀請',
  STUDENT_TABLE_REGISTER: '註冊學生',
  STUDENT_TABLE_SAVE: '儲存',
  STUDENT_ADD: '新增學生',
  STUDENT_SUCCESS_CREATE_MESSAGE: '已新增學生',
  STUDENT_SUCCESS_SAVE_MESSAGE: '學生資料更新成功',

  // Group
  GROUP_TITLE: '班級',
  GROUP_TITLE_SINGULAR: '班級',
  GROUP_FORM_LEFT_PATH_TITLE: '基本欄位',
  GROUP_FORM_RIGHT_PATH_TITLE: '其他欄位',
  GROUP_TABLE_CREATE_TITLE: '新增班級',
  GROUP_TABLE_SAVE_TITLE: '編輯班級資料',
  GROUP_TABLE_CREATE: '新增',
  GROUP_TABLE_SAVE: '儲存',
  GROUP_SUCCESS_CREATE_MESSAGE: '已新增班級',
  GROUP_SUCCESS_SAVE_MESSAGE: '班級資料更新成功',

  // School
  SCHOOL_TITLE: '學校',
  SCHOOL_FORM_LEFT_PATH_TITLE: '學校管理員資料',
  SCHOOL_FORM_RIGHT_PATH_TITLE: '學校資訊',
  SCHOOL_TABLE_CREATE_TITLE: '新增學校',
  SCHOOL_TABLE_SAVE_TITLE: '編輯學校資料',
  SCHOOL_TABLE_CREATE: '新增',
  SCHOOL_TABLE_SAVE: '儲存',
  SCHOOL_SUCCESS_CREATE_MESSAGE: '已新增學校',
  SCHOOL_SUCCESS_SAVE_MESSAGE: '學校資料更新成功',
  SCHOOL_INFO: '學校資訊',

  // Teacher
  TEACHER_TITLE: '教師',
  TEACHER_FORM_LEFT_PATH_TITLE: '基本欄位',
  TEACHER_FORM_RIGHT_PATH_TITLE: '其他欄位',
  TEACHER_TABLE_CREATE_TITLE: '新增教師',
  TEACHER_TABLE_SAVE_TITLE: '編輯教師資料',
  TEACHER_TABLE_CREATE: '新增',
  TEACHER_TABLE_SAVE: '儲存',
  TEACHER_SUCCESS_CREATE_MESSAGE: '已新增教師',
  TEACHER_SUCCESS_SAVE_MESSAGE: '教師資料更新成功',

  // Homework
  HOMEWORK_TITLE: '作業',
  HOMEWORK_TITLE_SETTINGS: '作業設定',
  HOMEWORK_TITLE_SINGULAR: '作業',
  HOMEWORK_FORM_LEFT_PATH_TITLE: '參數設定',
  HOMEWORK_FORM_RIGTH_PATH_TITLE: '使用者設定',
  HOMEWORK_TABLE_CREATE_TITLE: '建立',
  HOMEWORK_TABLE_SAVE_TITLE: '編輯',
  HOMEWORK_TABLE_CREATE: '建立',
  HOMEWORK_TABLE_SAVE: '儲存',
  HOMEWORK_SUCCESS_CREATE_MESSAGE: '已新增作業',
  HOMEWORK_SUCCESS_SAVE_MESSAGE: '作業更新成功',
  HOMEWORK_STARTED_CARRY_OUT: '已開始做作業',
  LAST_WEEK_DATES: '已批改的作業依完成日期顯示，保留 7 天',

  // Exams
  EXAMS_TITLE: '考試',
  EXAMS_TITLE_SINGULAR: '考試',
  EXAMS_FORM_LEFT_PATH_TITLE: '考試參數',
  EXAMS_FORM_RIGHT_PATH_TITLE: '考試統計',
  EXAMS_TABLE_CREATE_TITLE: '新增考試',
  EXAMS_TABLE_SAVE_TITLE: '編輯考試',
  EXAMS_TABLE_CREATE: '建立',
  EXAMS_TABLE_SAVE: '儲存',
  EXAMS_SUCCESS_CREATE_MESSAGE: '考試建立成功',
  EXAMS_SUCCESS_RESULT: '考試成績儲存成功',
  EXAMS_SUCCESS_SAVE_MESSAGE: '考試資料更新成功',
  EXAM_SUCCESS_SAVE: '連結儲存成功',

  // Book / Workbook
  WORKBOOK_BUTTON: '產生題目',
  WORKBOOK_TITLE: '可列印題目',
  CERTIFICATION_TITLE: '檢定',
  CERTIFICATION_SIMULATE_TITLE: '模擬',
  SIMULATE_PAUSE: '比賽模擬已暫停，請稍候',
  CERTIFICATION_SIMULATE_SAMA_TITLE: 'SAMA GLOBAL 模擬',
  CERTIFICATION_SIMULATE_PAMA_TITLE: 'PAMA GLOBAL 模擬',
  CERTIFICATION_SIMULATE_UAMAP_TITLE: 'UAMAP 模擬',
  CERTIFICATION_EXAM_TITLE: '考試',
  BOOK_TITLE: '團隊合作',
  WORKBOOK_TO_PRINT: '傳送至印表機',

  // Icons
  CAR_ICON: '汽車',
  PLANE_ICON: '飛機',
  ELEPHANT_ICON: '小象',
  HELICOPTER_ICON: '直升機',
  TIGER_ICON: '小老虎',
  FOX_ICON: '小狐狸',
  FAWN_ICON: '小鹿',
  CROCODILE_ICON: '鱷魚',
  SQUIRREL_ICON: '小松鼠',
  BEAR_ICON: '小熊',
  WOLF_ICON: '小狼',
  LEOPARD_ICON: '豹',

  // Common UI
  COLUMN: '直式',
  SIMULATORS: '訓練工具',
  EDIT_PROFILE: '編輯個人資料',
  EXIT_INSIDE_PROFILE: '離開',
  NAME: '姓名',
  SURNAME: '姓氏',
  NAME_EN: '英文名字',
  SURNAME_EN: '英文姓氏',
  SEX: '性別',
  MIDDLE_NAME: '中間名',
  STATUS: '狀態',
  TRANSACTION_STATUS: '狀態',
  EXAM_LINK: 'Yandex 連結',
  CITY: '城市',
  EMAIL: '電子郵件',
  EMAIL_SHORT: '電子郵件',
  PHOTO_LINK: '參賽者照片連結',

  // Main Page Rooms
  MAIN_PAGE_ROOMA_TITLE: '快速存取：暗算',
  MAIN_PAGE_ROOMA_DESCRIPTION: '在此區塊可以查看並提升你的技能',
  MAIN_PAGE_ROOMB_TITLE: '快速存取：直式',
  MAIN_PAGE_ROOMB_DESCRIPTION: '在此區塊可以查看並提升你的技能',
  MAIN_PAGE_ROOMC_TITLE: '快速存取：閃卡',
  MAIN_PAGE_ROOMC_DESCRIPTION: '在此區塊可以查看並提升你的技能',
  DETAIL: '更多詳情...',
  SET_YOUR_DATE_OF_BIRTH: '請輸入出生日期',

  // Roles
  ROLE_GUEST: '未登入',
  ROLE_STUDENT: '學生',
  ROLE_TEACHER: '教師',
  ROLE_SCHOOL: '學校',
  ROLE_ADMIN: '管理員',
  ROLE: '使用者類型',

  // Settings
  CABINET: '個人主頁',
  SETTINGS: '設定',
  BASIC_SETTINGS: '基本設定：',
  ADDITIONAL_SETTINGS: '詳細設定：',
  TRAINER_SETTINGS: '訓練工具設定',

  // Trainer Parameters
  room: '教室',
  amount: '題目數量',
  OLIMPIC_SAMPLES_TITLE: '題',
  section: '單元',
  animation: '動畫',
  windows: '畫面數量',
  simulator: '訓練工具',
  steps: '數字個數',
  period: '題目間隔',
  INTERVAL: '顯示速度',
  interval: '顯示速度',
  ACTIVATE_NEGATIVE: '啟用負數',
  NEGATIVE_ANSWER: '答案可為負數',
  mode: '主題',
  sign: '運算符號',
  bound: '進退位',
  under: '從',
  over: '到',
  of: '之',
  rule: '規則',
  numbers: '單元',
  formulas: '數字公式：',
  formulas_once: '公式：',
  student: '學生',
  students: '學生',
  individ: '個別',
  date: '日期',
  dates: '日期',
  daily: '每日',
  daily_over: '每日直到',
  numbers_of_terms: '數字個數',
  numbers_in_example: '每題數字個數',
  comment: '備註',

  // Multiplication / Division
  first_int_available_numbers: '第一乘數',
  second_int_available_numbers: '第二乘數',
  order_first_int_available_numbers: '第一乘數位數',
  order_second_int_available_numbers: '第二乘數位數',
  DIVISION: '除法',
  MULTIPLICATION: '乘法',
  MULTIDIVISION: '乘法/除法',
  divider: '除數',
  dividend: '被除數',

  // Animation Types
  FADING: '淡出',
  SLIDE_UP: '向上滑動',
  SLIDE_DOWN: '向下滑動',
  SLIDE_LEFT: '向左滑動',
  SLIDE_RIGHT: '向右滑動',
  BIGGER_FONT: '放大字體',
  SMALLER_FONT: '縮小字體',
  RANDOM_PLACE: '隨機位置',
  MULTICOLORED_NUMBERS: '彩色數字',
  NO_ANIMATIONS: '無動畫',

  // Training Rooms
  roomA: '暗算',
  roomB: '直式',
  roomC: '閃卡',
  roomD: '舒爾特方格',
  anzan_title: '暗算',
  columns_title: '直式',
  cards_title: '閃卡',
  schulte_table_title: '舒爾特方格',

  // Math Parameters
  MINIMUM_RATE: '最小答案位數',
  MAXIMUM_RATE: '最大答案位數',
  BOTH_ARE_SMALLER: '兩者皆小',
  BOTH_ARE_BIGGER: '兩者皆大',
  OPPOSITE_SIDES: '兩側相反',

  // Controls
  START: '開始',
  STOP: '停止',
  MIX: '混合',
  CLOSE: '關閉',
  CHECK: '檢查',
  ANSWER: '答案',
  ANSWERS: '答案',
  PROGRESS: '載入中',
  ENTER_ANSWER: '輸入答案',

  // Reports
  REPORT_TITLE: '統計顯示所有區塊的已完成任務：作業和遠端解決的題目。',
  REPORT_DESCRIPTION:
    '正確/錯誤答案數量顯示在左側縱軸；參數中位數：顯示速度、數字個數、數字位數標記在右側縱軸。',
  NUMBER_OF_TERMS: '數字個數',
  NUMBER_RANK: '數字位數',
  digit: '位數',
  FILTER: '篩選',

  // Results
  SUCCESS: '正確',
  FAIL: '錯誤',
  RATE: '評分',
  ADDRESS: '地址',
  DESCRIPTION: '說明',
  FULL_NAME: '全名',
  SUCCESS_ALL: '正確/總數',
  OPERATION: '運算',
  TOTAL_TASKS: '總任務數',
  TASKS: '任務',
  TOTAL_SUCCESS: '正確答案數',

  // Homework
  REPORT_HOMEWORK:
    '縮寫：(R) - 規則、(S) - 單元、(F) - 公式、(Sg) - 符號、(TP) - 時間段、(NC) - 數字個數、(PV) - 位數、(PM) - 第一乘數、(SM) - 第二乘數',
  ADD_HOMEWORK: '建立',
  DELETE_HOMEWORK: '刪除作業',
  DELETE_SELECTED: '刪除所選',
  SAVE_HOMEWORK: '完成並儲存',
  WARNING_HOMEWORK: '變更將影響所有學生！',
  WARNING_HOMEWORK_DELETE: '確定刪除此作業？',
  WARNING_HOMEWORK_CHECK: '將作業標記為已批改？',
  WARNING_HOMEWORK_EDIT: '學生已開始做作業，結果將被重置',
  WARNING_HOMEWORK_CANT_EDIT: '無法編輯已完成的作業！',
  WARNING_HOMEWORK_CANT_DELETE: '無法刪除已完成的作業！',
  SHOW_SOLUTION: '顯示解答',
  MARK_COMPLETE: '評分',
  GO_TO_HOMEWORK: '前往作業',

  // Filter & Pagination
  FILTER_ALL: '全部記錄',
  FILTER_TITLE: '篩選',
  FILTER_RESET: '重設篩選',
  PAGINATION_NEXT: '下一頁',
  PAGINATION_PREVIOUS: '上一頁',
  PAGINATION_ROWS_PER_PAGE: '每頁筆數：',
  PAGINATION_DISPLAY_ROWS: '/',
  VIEW_COLUMN_TITLE: '顯示/隱藏欄位',
  VIEW_COLUMN_TITLE_AREA: '顯示/隱藏欄位',
  VIEW: '顯示',
  HIDE: '隱藏',
  BODY_NO_MATCH: '找不到符合的記錄',
  BODY_NO_TOOL_TIP: '排序',
  BODY_NO_COLUMN_HEADER_TOOLTIP: '排序：',
  SELECTED_ROWS_TEXT: '筆已選取',
  SELECTED_ROWS_TEXT_HOMEWORKS: '已批改',
  SELECTED_ROWS_DELETE: '刪除',
  SELECTED_ROWS_DELETE_ARIA: '刪除所選記錄',
  FILTERING: '篩選',

  // Math Sections
  NEGATIVE_NUMBERS: '負數',
  SECTION_UP_TO_FOUR: '1-4 以內',
  SECTION_UP_TO_FIVE: '5 以內',
  SECTION_UP_TO_SIX: '6 以內',
  SECTION_UP_TO_SEVEN: '7 以內',
  SECTION_UP_TO_EIGHT: '8 以內',
  SECTION_UP_TO_NINE: '9 以內',
  SECTION_MIRROR: '鏡像數字',
  SECTION_TEN: '整數',

  // Division
  DIVISION_TABLE: '除法表',
  DIVISION_REMAINDER: '有餘數的除法',
  DIVISION_SIMPLE: '簡單除法 4D/2D',
  DIVISION_ONE_ITERATE: '一次試商除法 4D/2D',
  DIVISION_MORE_ITERATE: '兩次以上試商除法 4D/2D',
  DIVISION_SAME: '首位相同除法 4D/2D',
  DIVISION_BY_ONE: '除以 1 的除法 4D/2D',
  DIVISION_RANDOM: '隨機除法',
  DIVISION_FIRST: '被除數',
  DIVISION_SECOND: '除數',

  // Multiplication
  MULTIPLICATION_TABLE: '乘法表',
  MULTIPLICATION_SIMPLE: '簡單乘法',
  MULTIPLICATION_RANDOM: '隨機乘法',
  MULTIPLICATION_ONE_ITERATE: '含 0 的乘法',
  MULTIPLICATION_MORE_ITERATE: '含 5 的乘法',
  MULTIPLICATION_FIRST: '乘數 1',
  MULTIPLICATION_SECOND: '乘數 2',
  MULTIPLIER: '乘數',

  // Advanced Math
  DECIMAL_MODE: '小數',
  SQRT: '平方根',
  CURT: '立方根',
  SQUARE: '平方數',
  CUBE: '立方數',
  ANSWER_DISCHARGE: '答案位數',
  ANSWER_DISCHARGE_TYPE: '答案',
  RANDOM_TYPE: '隨機',
  SMALL_FISH: '最小答案位數（小魚）',
  BIG_FISH: '最大答案位數（大魚）',
  SMALL_MOUSE: '最小答案位數（小老鼠）',
  BIG_MOUSE: '最大答案位數（大老鼠）',

  // Rotation Types
  ROTATION_TYPE: '位數交替',
  RANDOM_ROTATION: '隨機',
  SINGLE_ROTATION: '單一',
  DOUBLE_ROTATION: '雙重',

  // Answers
  NUMERALS: '數字',
  RIGHT_ANSWERS: '正確答案',
  RIGHT_ANSWER: '正確答案 ',
  WRONG_ANSWERS: '錯誤答案',

  // Simulator Settings
  SIMULATOR_TYPE: '訓練工具類型',
  SIMULATOR_SETTINGS: '訓練工具參數',
  PARAMS: '參數',
  NUMBER_OF_WINDOWS: '畫面數量',
  NUMBER_OF_EXAMPLES: '題目數量',
  count: '題目數量',
  COMPLETION_TIME: '時間',
  TIME_LIMIT_VALUE: '時間限制（分:秒）',
  TIME_LIMIT_MODE: '時間模式',
  LIMITED_TIME: '限時',
  UNLIMITED_TIME: '不限時',
  RESTART: '重新開始',

  // Division Components
  CEIL: '整數',
  REMAINDER: '餘數',
  SECOND: '秒',
  TERMS: '運算元',

  // Base System
  base: '基準',
  base_side: '基準兩側',
  digits_mode: '位數模式',
  DIGITS_MODE_MIN_RANGE: '最小答案位數',
  DIGITS_MODE_MAX_RANGE: '最大答案位數',
  DIGITS_MODE_RANDOM_RANGE: '隨機',
  BASE_SIDE_LESS: '兩者皆小於基準',
  BASE_SIDE_MORE: '兩者皆大於基準',
  BASE_SIDE_DIFF: '基準兩側相反',

  // EXCEED
  NOT_EXCEED_50: '無進退位',
  NOT_EXCEED_100: '超過 50',
  EXCEED_100: '超過 100',

  // Dictation
  DICTATION_AMOUNT: '題目數量',
  DICTATION_PERIOD: '題目間隔',
  DICTATION_START: '開始聽寫',
  DICTATION_STOP: '停止聽寫',
  DICTATION_NEXT: '繼續聽寫',

  // School Information
  SCHOOL_NAME: '名稱',
  SCHOOL_CITY: '城市',
  SCHOOL_ADDRESS: '地址',
  SCHOOL_METRO_STATION: '捷運站',
  SCHOOL_FULL_NAME_OF_HEAD: '負責人全名',
  PHONE: '電話',
  PREVIOUS_PAGE: '上一頁',
  NEXT_PAGE: '下一頁',
  EDIT_DATA: '編輯資料',
  ADD_RECORD: '新增記錄',
  DELETE_RECORD: '刪除記錄',
  RESTORE_USER: '恢復使用者',
  RECORD_PER_PAGE: '每頁筆數',
  PASSWORD: '密碼',
  DATE_REGISTRATED: '註冊日期',
  DATE_BEGINING: '開始日期',
  DATE_ENDING: '結束日期',
  DATE_CREATING: '建立日期',
  DATE_DELETED: '刪除日期',
  BY_DAYS: '依天數',
  CREATED: '已建立',

  // UI Elements
  SELECTED: '請選擇...',
  NOT_RECORD: '無記錄',
  NOT_FOUND_CATEGORIES_FOR_OLIMPIC: '找不到符合您出生年份的類別',
  DIRECTORY_STUDENTS_TITLE:
    '所有自行在平台上註冊的學生，包括透過推薦連結註冊的學生',
  ICON: '圖示',

  // User Interface
  user_guide: '使用者指南',
  user_online: '線上：{count}',
  _users: '位使用者',
  _online: '線上',
  RESET: '重設',
  CHOOSE_THEME: '選擇主題',
  ABACUS_DESCRIPTION: '使用虛擬算盤和白板來解說新主題。',
  MARKS: '如何在算盤上做標記',
  ABACUS: '算盤',
  DESK: '白板',

  // Student Management
  GROUPS: '班級',
  EMAIL_STUDENT: '學生電子郵件',
  NAME_SURNAME_STUDENT: '學生姓名',
  AGE: '年齡',
  EMAIL_PARENT: '家長電子郵件',
  NAME_SURNAME_PARENT: '家長姓名',
  ACTIVE: '啟用',
  SEND_EMAIL_TO_STUDENT: '將登入資訊發送到此電子郵件',
  DATEBIRTH: '出生日期',
  YES: '是',
  NO: '否',
  SEARCH: '搜尋',
  SEARCH_STUDENTS: '搜尋學生',
  SEARCH_DATE: '搜尋日期',
  REPEAT_PASSWORD: '重複密碼',
  I_AGREE: '我同意隱私權政策和使用條款',

  // Certification
  WITH_ANSWER: '在示例中包含答案',
  WITH_ANSWER_SEPARATE_SHEET: '答案单独一页',
  TO_PRINT: '列印',

  // Certification Pages
  CERTIFICATION_PAGE_TITLE_SAMA: 'SAMA GLOBAL 算盤與珠心算檢定',
  CERTIFICATION_PAGE_TITLE_PAMA: 'PAMA GLOBAL 算盤與珠心算檢定',
  CERTIFICATION_PAGE_TITLE_UAMAP: 'UAMAP 珠心算考試',
  CERTIFICATION_LEVEL_TIME: '時間',
  MIN: '分鐘',
  MENTAL_ARITHMETIC: '心算',
  ARITHMETIC_FOR_CHILDREN: '兒童等級',
  ARITHMETIC_FOR_TEACHER: '教師等級',
  FOR_CHILDREN: '兒童',
  FOR_TEACHER: '教師',
  ABACUS_ARITHMETIC: '算盤計算',
  MENTAL_ARITHMETIC_ADD: '心算（+,-）',
  ABACUS_ARITHMETIC_ADD: '算盤計算（+,-）',
  MENTAL_ARITHMETIC_MULTIPLICATION: '心算（×）',
  ABACUS_ARITHMETIC_MULTIPLICATION: '算盤計算（×）',
  MENTAL_ARITHMETIC_DIVISION: '心算（÷）',
  ABACUS_ARITHMETIC_DIVISION: '算盤計算（÷）',
  ADD: '加法',
  CARD: '珠像',
  FIVE: '5 的合成',
  TEN: '10 的合成',
  NEXT_LEVEL: '下一題',
  NEXT_TEST: '再做一次測驗',
  RESULT: '結果',
  SCORE: '分數',
  LEVEL: '等級',
  LEVEL_1: '等級 1',
  LEVEL_2: '等級 2',
  LEVEL_3: '等級 3',
  LEVEL_4: '等級 4',
  LEVEL_5: '等級 5',
  LEVEL_6: '等級 6',
  LEVEL_7: '等級 7',
  LEVEL_7_A: '等級 7 A',
  LEVEL_7_B: '等級 7 B',
  LEVEL_8: '等級 8',
  LEVEL_8_A: '等級 8 A',
  LEVEL_8_B: '等級 8 B',
  LEVEL_9: '等級 9',
  LEVEL_9_A: '等級 9 A',
  LEVEL_9_B: '等級 9 B',
  LEVEL_10: '等級 10',
  LEVEL_10_A: '等級 10 A',
  LEVEL_10_B: '等級 10 B',
  LEVEL_11: '等級 11',
  LEVEL_12: '等級 12',
  LEVEL_13: '等級 13',
  LINK_BY_VIDEO: '雲端連結',
  SAVE_RESULT_BY_TEST: '儲存考試成績',
  STARTING_EXAM: '開始考試',
  ABACUS_TYPE: '算盤，',
  MENTAL_TYPE: '心算',
  ADD_TYPE: '加法與減法（+, -）',
  MULTIPLICATION_TYPE: '乘法（×）',
  MULTIPLICATION_TABLE_TYPE: '乘法表（×）',
  MULTIDIVISION_TYPE: '乘法與除法表',
  MULTIDIV_TYPE: '乘法與除法',
  DIVISION_TABLE_TYPE: '除法表（÷）',
  DIVISION_TYPE: '除法（÷）',
  TIE_TYPE: '加賽',
  PRINT_CERTIFICATION: '列印檢定證書',
  CREATE_CERTIFICATION: '建立檢定證書',
  EXAM_CHECKING: '考試審核中',
  EXAM_STATUS_NOT_FOUND: '考試狀態未確定',
  EXAM_WAITING_RUN: '考試已建立，等待學生在個人帳號中完成',
  SET_CODE: '輸入代碼',
  CHECK_CODE: '驗證',
  CERTIFICATION_NOT_FOUND: '找不到此代碼的證書，請重試。',

  // Navigation
  SCHEDULE_TITLE: '課表',
  PROFILE_TITLE: '個人檔案',
  NEWS_TITLE: '最新消息',
  NEWS_EDIT_TITLE: '動態',
  NEWS_FEED_TITLE: '管理',
  DELEGATES: '代表',
  TEAM_MODE_TITLE: '團隊模式',
  OLIMPIC_TITLE: '比賽',
  FOR_PARENTS_TITLE: '家長專區',

  // Actions
  REGISTER: '報名',

  // Homework Status
  HOMEWORK_STATUS: '狀態',
  COMPLETED: '已完成',
  OVERCOMPLETE: '超額完成',
  UNCOMPLETED: '未完成',

  // General
  USER: '使用者',
  CERTIFICAT: '證書',
  CATEGORY: '類別',
  mark: '分',

  // Country & Exam
  COUNTRY: '國家',
  EXAM_RESULT: '考試成績',
  GENERATE_XLSX: '產生 XLSX',
  GENERATE_SAMA_XLSX: '產生 SAMA XLSX',
  GENERATE_PAMA_XLSX: '產生 PAMA XLSX',
  SAVE_TO_COMPUTER: '儲存到電腦',
  CHANGE_RANKS: '修改所選',
  SET_OLIMPIC_RANKS: '選擇要指派給參賽者的名次',

  // Ranking System
  STARS: '星星',
  STARS_FOR_HOMEWORK: '作業星星數',
  RANK: '稱號',
  RANK_1: '新手',
  RANK_2: '初學者',
  RANK_3: '記帳士',
  RANK_4: '專家',
  RANK_5: '博學者',
  RANK_6: '資優生',
  RANK_7: '萬事通',
  RANK_8: '奇才',
  RANK_9: '神童',
  RANK_10: '天才',
  PLACE_IN_RATING: '排名',
  NO_RATE: '未參加',
  FEATHERS: '羽毛',
  PROGRESS_TO_NEXT_RANK: '下一稱號進度',

  // Payments & Accounts
  SUMM: '金額',
  PURPOSE_OF_PAYMENT: '付款用途',
  ENTER_PASSWORD: '輸入密碼',
  CONFIRM_IS_PARENT: '為確認您為家長，請輸入目前帳號密碼',
  BALANCE: '餘額',
  UCOINS1: 'U 幣',
  UCOINS2: 'U 幣',
  UCOINS5: 'U 幣',
  ACCESS_TO_PLATFORM: '平台存取權',
  INFINITY_ACCESS_TO_PLATFORM: '無限平台存取權',
  WAIT_PAY: '等待付款。線上結帳頁面已於另一個瀏覽器分頁中開啟',
  PAY: '付款',
  FREE: '免費',
  CERT_EXAM: '檢定考試',
  CERT_EXAMS: '檢定考試',
  OLIMPIC_PARTICIPATION: '比賽參加',
  OLIMPIC_PARTICIPATIONS: '比賽參加次數',
  CERT_SAMA_GLOBAL_EXAM: '已購買 SAMA GLOBAL 考試',
  CERT_PAMA_GLOBAL_EXAM: '已購買 PAMA GLOBAL 考試',
  CERT_UAMAP_EXAM: '已購買 UAMAP 考試',
  OLIMPIC_ONLINE_PARTICIPATION: '線上比賽參加次數',
  OLIMPIC_OFFLINE_PARTICIPATION: '實體比賽參加次數',
  OLIMPIC_SAMA_PARTICIPATION: 'PAMA 比賽參加次數',
  REGISTER_STUDENTS: '學生存取權套餐',
  PURCHASED: '已購買',
  DAYS_ON_PLATFORM: '使用平台天數',
  DAYS_LEFT: '剩餘天數',
  SUSPENDED: '已暫停',
  UNTIL: '至',
  PROLONG: '延長',
  TOP_UP_ACCOUNT: '儲值',
  SAVE_CHANGES: '儲存變更',
  MOBILE_PHONE: '手機',
  REFERALS_TITLE: '推薦系統',
  MANAGEMENT: '管理',
  ABOUT_GAMIFICATION: '關於遊戲化',
  UCOINS_TITLE: 'U 幣',
  STATISTICS: '統計',
  THEMATIC: '主題',
  CONTENT: '內容',
  BACK: '返回',

  // Errors & Messages
  ERROR_INCORRECT: '您輸入的密碼不正確',
  DEADLINE_ERROR: '請設定每日作業的截止日期（最長 1 個月）',
  CONFIRM_PAYMENT: '確認後將從您的餘額中扣除所選服務的費用',
  PAYMENT_LIMIT_WARNING: '海外使用者僅支援 MIR 和 BELKART 卡片付款',
  PURCHASE_ERROR: '發生錯誤',
  PURCHASE_NOT_ENOUGH: '餘額不足',
  PURCHASE_SUCCESS: '購買成功',
  NOT_ENOUGH_PACK: '套餐中的存取權不足',
  HAVE_ONLINE_OLIMPIC: '該使用者已有線上比賽存取權',
  HAVE_OFFLINE_OLIMPIC: '該使用者已有實體比賽存取權',
  HAVE_MAINTAINERS: '該使用者已有實體比賽陪同者門票',
  NOT_REGISTERED_OFFLINE_OLIMPIC: '您尚未報名實體比賽',
  REGISTER_STUDENT_ISUFFICIENT_FUNDS:
    '若要自行註冊學生，請在商店購買適合的存取權套餐',
  ACCESS_ISUFFICIENT_FUNDS: '平台存取權已到期。請在「家長/管理」區塊中續費',
  ACCESS_NO_DEMO_FUNDS: '請在「家長/管理」區塊中購買平台存取權',
  ACCESS_ISUFFICIENT_FUNDS_TEACHER:
    '您需要至少 1 位已付費的學生。您可以自行付費',
  SAMA_ACCESS_MESSAGE:
    '很抱歉，您目前無法參加比賽。請在該區塊中購買 SAMA GLOBAL 比賽存取權',
  PAMA_ACCESS_MESSAGE:
    '很抱歉，您目前無法參加比賽。請在該區塊中購買 PAMA GLOBAL 比賽存取權',
  NO_ACCESS: '此區塊無法使用',
  ACCESS_NO_OLIMPIC: '需要付費才能參加比賽',

  // Products
  PRODUCTS_TITLE: '價格',
  PRODUCTS_LEARNER: '學生產品',
  PRODUCTS_TEACHER: '教師與學校產品',
  PRODUCTS_SCHOOL: '學校產品',
  PRODUCTS_TEACHER_ASSOC: '協會代表、教師產品',
  PRODUCTS_SCHOOL_ASSOC: '協會代表、學校產品',
  PRODUCTS_ASSOC: '協會代表產品',
  CONFIRM_PAY_PRODUCT: '確定以 {price} 盧布購買「{product}」？',
  CONFIRM_PRODUCT: '將從餘額中扣除 {price} U 幣以支付 {name}。',
  CONFIRM_PRODUCT_SELF: '將從餘額中扣除 {price} U 幣。',
  CONFIRM_PAYMENT_PACKAGE: '確定從已購買的存取權套餐中為學生 {name} 付費？',
  CONFIRM_BUY_PACK: '確定為 {name} 購買存取權套餐？',
  CONFIRM_PACK: '將以 {price} U 幣購買 {count} 位學生的存取權套餐',
  PACKAGES_AMOUNT: '存取權套餐',

  // UI Elements
  OK: '確定',
  CONFIRM: '確認',
  CONTINUE: '繼續',
  CANCEL: '取消',
  REFUSE: '拒絕',
  PURCHASES: '購買記錄',
  currency: 'U 幣',
  currency_short: 'U',
  CURRENCY_EQUAL: '1 盧布 = 1 U 幣',
  ENTER_AMOUNT: '輸入儲值金額',
  NOT_SELECTED: '未選擇',

  // Mental Arithmetic
  MENTAL_ARITHMETIC_TITLE: '珠心算',
  ROOM_SHORT: '教室',
  TIME: '時間',
  min: '分鐘',
  EACH_Q: '正確答案',
  marks: '分',
  DATE: '日期',
  DATE_FORMAT: 'DD.MM.YYYY',
  SAVE: '儲存',
  SAVE_LINK: '儲存連結',
  link: '連結',
  ADD_LESSON: '新增課程',

  // Referral
  RECEIVE_BONUSES: '邀請新學生或教師即可獲得獎勵',
  REFERAL_LINK_FOR_STUDENTS: '學生推薦連結',
  REFERAL_LINK_FOR_TEACHERS: '教師推薦連結',
  COPY: '複製',
  ABOUT_REFERAL_ADMIN: '關於推薦系統',

  // Achievements
  ACHIEVEMENTS: '成就',
  NEW: '新',
  NEW_OR_COMPLETED: '新 / 已完成',
  TODAY_OR_ALL: '今天 / 全部',
  ALL_ACHIEVEMENTS: '所有成就',
  HERE_ALL_ACHIEVEMENTS: '在這裡可以查看所有成就，包括已獲得和未獲得的。',
  CLEAR: '知道了',

  // Assignments
  WORKS: '任務',
  HOME_WORKS: '作業',
  ALL_HOME_WORKS: '所有作業',
  HOME_WORKS_EMPTY: '沒有作業',
  ADD_TRAIN: '在此新增訓練工具',
  COMPLETE: '完成',
  COMPLETE_OVER: '截止日期',

  // Experience System
  FOR_RECEIVE_NEW_ACHIEVEMENTS: '累積經驗值以解鎖新成就',
  EXPERIENCE_GRADING: '經驗值等級',
  EXPERIENCE_REQUIRED: '所需經驗值',

  // Feathers System
  CONFIRM_RESET_FEATHERS: '確定要重設所有使用者的羽毛嗎？',
  FOR_RESET_FEATHERS: '點擊以重設所有使用者的羽毛',
  RESET_FEATHERS: '重設羽毛',
  CHAMPIONS_CORNER: '冠軍殿堂',
  PHOTO: '照片',
  OPEN_ALL_OLIMP_CHAMPIONS: '顯示所有比賽',

  // Ratings
  RATING: '排行榜',
  TEACHER_RATING: '教師排行',
  STUDENT_RATING: '學生排行',
  PLACE: '名次',
  place1: '第 1 名',
  place2: '第 2 名',
  place3: '第 3 名',
  PLACE_EN: '名',
  PLACE_LABEL: '名次（數字，0 表示冠軍）',
  OPEN_FULL_LIST: '查看完整名單',
  USERS_LIST: '使用者名單',
  YOUR_PLACE_IN_RATING: '你目前的排名',
  FOR_UP_IN_RATING_TEACHER: '想提升排名：獲得成就、進行課程、邀請新學生和教師',
  FOR_UP_IN_RATING_STUDENT: '想提升排名：多解題目並從成就中獲得羽毛',

  // User Information
  STUDENT_NAME: '學生姓名',
  TEACHER_NAME: '教師姓名',
  POINTS: '分數',
  TEACHER_ADD_STUDENT: '已將您的孩子加入其學生名單。確認此操作？',

  // Subscriptions
  SUBSCRIBE_1_MONTH: '1 個月訂閱',
  FROM_PACKET: '來自套餐',
  SUBSCRIBE_1_MONTH_PACKET: '套餐中的 1 個月訂閱',
  SUBSCRIBE_6_MONTH: '6 個月訂閱',
  SUBSCRIBE_12_MONTH: '1 年訂閱',

  // Certifications
  SAMA_CERT: 'SAMA GLOBAL 檢定',
  PAMA_CERT: 'PAMA GLOBAL 檢定',
  UAMAP_CERT: 'UAMAP 學生檢定',
  UAMAP_CERT_TEACHER: 'UAMAP 教師檢定',
  SAMA_CERT_SHORT: 'SAMA GLOBAL',
  PAMA_CERT_SHORT: 'PAMA GLOBAL',
  UAMAP_CERT_SHORT: 'UAMAP 學生',
  UAMAP_CERT_TEACHER_SHORT: 'UAMAP 教師',

  // Time Periods
  MONTH: '個月',
  MONTHS: '個月',
  STUDENT_GENITIVE: '學生的',
  STUDENTS_GENITIVE: '學生的',

  // Selection
  SELECT: '選擇',
  SELECT_PRODUCT: '選擇產品',
  SELECT_USER: '選擇使用者',
  SELECT_LEARNER: '選擇學生',
  SELECT_STUDENT: '選擇學生',
  SELECT_TEACHER: '選擇教師',
  SELECT_STUDENTS_AMOUNT: '選擇參賽人數',

  // Ucoins & Transactions
  ACCESS: '購買平台存取權：',
  REPLENISHMENT: '儲值',
  PACKET: '購買存取權套餐：',
  ACCESS_FROM_PACKET: '從套餐購買平台存取權',
  SAMA_PAYMENT: '購買 SAMA GLOBAL 檢定考試',
  PAMA_PAYMENT: '購買 PAMA GLOBAL 檢定考試',
  UAMAP_PAYMENT: '購買 UAMAP 檢定考試',
  ONLINE_OLIMPIC_PAYMENT: '購買線上比賽參加權',
  OFFLINE_OLIMPIC_PAYMENT: '購買實體比賽參加權',
  SAMA_OLIMPIC_PAYMENT: '購買 SAMA GLOBAL 比賽參加權',
  PAMA_OLIMPIC_PAYMENT: '購買 PAMA GLOBAL 比賽參加權',
  MAINTAINER_PAYMENT: '比賽陪同者',

  // Gamification Explanations
  GAMIFICATION_1:
    '遊戲化是將遊戲機制應用於非遊戲場景中。此遊戲化系統旨在提升使用者的參與度和興趣。排行榜根據教師及其學生的表現來建立。考試、推薦的學生和課程數量都會提升你的排名。',
  GAMIFICATION_2: '教師可以透過完成平台上的特定任務來獲得成就。',
  GAMIFICATION_3:
    '遊戲化與遊戲有關。在這裡你可以玩樂並成長。此分頁介紹了平台上的所有遊戲機制。羽毛是用來形成學生排行的分數。排行是根據每位學生的表現所建立的名單。稱號是透過獲得成就來提升的等級。成就是完成特定行動後獲得的獎勵。',
  GAMIFICATION_4: '現在讓我們來詳細了解',
  GAMIFICATION_5:
    '排行榜每 3 個月更新一次，讓頂尖的學生和教師有機會贏得豐厚的獎品。',
  GAMIFICATION_6:
    '排行根據學生賺取的羽毛數和教師的評分來建立。分數越多，排名越高。排名靠前的使用者將獲得實體和虛擬獎品。',
  GAMIFICATION_7: '成就有助於教師排名的提升。',
  GAMIFICATION_8:
    '想要獲得更多成就和評分：參加考試、進行課程，並積極使用平台。',
  GAMIFICATION_9: '同時也要激勵你的學生全心投入珠心算的世界。',
  GAMIFICATION_10: '記住這些，你就能登上排行榜的頂端！',
  GAMIFICATION_11:
    '成就是透過平台活動獲得的趣味徽章。每個成就都會帶來經驗值和羽毛。',
  GAMIFICATION_12:
    '成就在獲得時會變成彩色（目前是灰階）。你可以預覽潛在的獎勵。',
  GAMIFICATION_13: '評分是透過平台上的關鍵行動和成就來獲得的。',
  GAMIFICATION_14: '行動包括進行課程、指派作業和推薦使用者。',
  GAMIFICATION_15:
    '羽毛是學生排行的分數，透過成就和解題來獲得（越難的題目＝越多羽毛）。每 3 個月重設一次，以決定新的獲勝者。',
  GAMIFICATION_16:
    '稱號代表你透過完成任務和獲得成就的進度。經驗越多＝稱號越高。',
  GAMIFICATION_17:
    '每個等級都會獲得新的稱號和獨特的個人檔案頭像框。「天才」（等級 10）是最高稱號。',
  GAMIFICATION_18:
    '據說不是每個人都能達到...如果你達到了，就可以把平台當作遊戲「通關」了。',
  GAMIFICATION_19: '星星是教師對已完成作業的評價。',
  GAMIFICATION_20: '越努力＝越多星星。成為你教師最優秀的學生吧！',

  // Referral System
  REFERAL_ADMIN: '推薦系統',
  MOVE_UCOINS_TO_BALANCE: '將 U 幣轉入餘額',
  INVITED_STUDENTS: '已推薦的學生',
  ACTIVE_STUDENTS: '擁有平台存取權的活躍學生',
  INVITED_TEACHERS: '已推薦的教師',
  EARNED_UCOINS: '已賺取的 U 幣',
  REFERAL_TEXT_1: '透過推薦系統，你可以免費賺取 U 幣。',
  REFERAL_TEXT_2: '讓新學生透過你的連結註冊並付費訂閱。',
  REFERAL_TEXT_3: '每位學生你將獲得 25 U 幣。',
  REFERAL_TEXT_4: '透過你的連結推薦學生和教師，即可免費賺取 U 幣。',
  REFERAL_TEXT_4_S:
    '當學生或教師透過你或你的教師的連結註冊時，即可免費賺取 U 幣。',
  REFERAL_TEXT_5: '當你推薦的學生首次付費購買平台存取權時，可獲得 25 U 幣。',
  REFERAL_TEXT_5_S: '當你或你的教師推薦的學生首次付費時，可獲得 25 U 幣。',
  REFERAL_TEXT_6: '當你推薦的教師有學生付費時，可獲得 50 U 幣。',
  REFERAL_TEXT_6_S: '當你或你的教師推薦的教師有學生付費時，可獲得 50 U 幣。',
  REFERAL_TEXT_7: '賺取你推薦的學生儲值金額的 5%。',
  REFERAL_TEXT_7_S: '賺取你或你的教師推薦的學生儲值金額的 2%。',

  // Olympiad / Competition
  PERSONAL_RATING: '個人排行',
  PUBLIC_RATING: '總排行',
  RATING_UPDATE: '排行榜每天 00:00（莫斯科時間）更新',
  SCORES_TITLE: '評分',
  RESULTS: '成績',
  RESULTS_NOTICE: '名次可能因缺少影片或上屆獲勝者參加同級別比賽但未升級而下降',
  PARTICIPATE: '參加',
  PARTICIPATE_OFFLINE: '參加實體比賽',
  OFFLINE_OLIMPIC_PARTICIPATE_NOTICE:
    '現在，填寫所有欄位並點擊「參加」以報名比賽',
  OLIMPIC_REGLAMENT_NOTICE: '請仔細閱讀比賽規章！',
  GET_READY: '準備好了！',
  CURRENT_PING: '目前連線品質',
  SEC: '秒',
  GOOD: '良好',
  NORMAL: '正常',
  WORST: '不佳',
  DISCONNECTED: '已斷線',
  OLIMPIC_TYPE: '比賽類型',
  olimpic_files: '上傳檔案並填入所需連結',
  OLIMPIC_LINK_REQUIRED_NOTIFY:
    '影片連結為必填，否則獎項名次將被降低！請確保影片的存取權限已開啟。你也可以在比賽結束後、成績審核前附上連結',
  OLIMPIC_START_NOTIFY:
    '祝你好運並獲得勝利！點擊「開始比賽」按鈕後，你將無法返回，只有 1 次機會。整個比賽過程必須從頭到尾錄影。請將影片上傳至任何雲端儲存空間並附上連結。',
  OLIMPIC_PRE_RUN_NOTIFY: '確認你已準備好，並等待準備倒數計時結束',
  IVE_READ_RULES: '我已仔細閱讀並同意上述規則',
  PREPARED_CAMERA: '我已準備好用攝影機錄製比賽過程，並同意提供影片以供審核',
  OLIMPIC_TECHNICAL_REQUIREMENT:
    '請檢查網路連線品質。禁止切換分頁、重新啟動或重新整理頁面，否則你的參賽資格將被終止！',
  IM_READY:
    '我已準備好開始比賽。我的連線沒有問題，且在比賽成績儲存之前不會離開此頁面。',
  ABOUT_OLIMPIC: '比賽',
  SAMA_OLIMPIC: 'Sama Global',
  PAMA_OLIMPIC: 'Pama Global',
  PAY_OFFLINE_SELF: '為自己購買門票',
  PAY_OTHER_OFFLINE: '為他人購買門票',
  OFFLINE_OLIMPIC: '實體',
  OFFLINE_OLIMPIC_FOR_STUDENT: '學生實體比賽',
  OFFLINE_OLIMPIC_FOR_TEACHER: '教師實體比賽',
  ONLINE: '線上',
  ONLINE_LEARNER: '學生線上比賽',
  ONLINE_TEACHER: '教師線上比賽',
  OLIMPIC_REQUIRE_PAYMENT: '需要付費才能參加比賽',
  ACCESS_REQUIRE_PAYMENT: '需要付費才能使用平台',
  REQUIRE_FIELDS: '所有欄位必須填寫',
  OLIMPIC_LIST: '比賽列表',
  OLIMPIC_NOT_FOUND: '未找到即將舉行的比賽',
  WILL_PASS: '訂於',
  CREATE: '新增',
  OLIMPIC_TABLE_CREATE_TITLE: '建立比賽',
  OLIMPIC_TABLE_EDIT_TITLE: '編輯比賽',
  OLIMPIC_TABLE_EDIT_PARTICIPANT: '編輯比賽參賽者',
  OLIMPIC_SUCCESS_CREATE_MESSAGE: '比賽建立成功',
  OLIMPIC_SUCCESS_EDIT_MESSAGE: '比賽更新成功',
  OLIMPIC_PRINT_TITLE: '列印題目',
  TIME_BEGINING: '開始時間',
  TIME_ENDING: '結束時間',
  OLIMPIC_SIMULATOR: '比賽模擬器',
  OLIMPIC_REGLAMENT: '比賽規章',
  OLIMPIC_GROUPS_TASKS: '分組任務',
  OLIMPIC_START_VIDEO_LINK: '比賽前影片連結',
  OLIMPIC_END_VIDEO_LINK: '比賽後影片連結',
  OLIMPIC_DIPLOMA_LINK_RU: '獎狀範本連結（俄文）',
  OLIMPIC_DIPLOMA_LINK_EN: '獎狀範本連結（英文）',
  OLIMPIC_GRATITUDE_LINK_RU: '感謝狀範本連結（俄文）',
  OLIMPIC_GRATITUDE_LINK_EN: '感謝狀範本連結（英文）',
  CUP_IMAGE_LINK: '獎盃圖片連結（冠軍殿堂）',
  OLIMPIC_SYLLABUS: '教學大綱',
  OLIMPIC_RUN: '開始比賽',

  // Competition Visibility & Reset
  SHOW_OFFLINE: '顯示實體比賽',
  SHOW_ONLINE: '顯示線上比賽',
  SHOW_SAMA: '顯示 PAMA',
  RESET_OLIMPIC_PAYMENTS: '重設比賽付款',
  RESET_FOR_ONLINE: '重設線上比賽',
  RESET_FOR_OFFLINE: '重設實體比賽',
  RESET_FOR_SAMA: '重設 PAMA',
  CONFIRM_RESET_ALL_OLIMPIC_PAYMENTS: '確定要重設所有比賽付款嗎？',

  // Competition Payment
  OLIMPIC_PAY_PARTICIPATE: '付費參加比賽',
  OLIMPIC_PAY: '付費參加',
  OFFLINE_OLIMPIC_PAY_PARTICIPATE: '付費參加實體比賽',
  SAMA_OLIMPIC_PAY_PARTICIPATE: '付費參加 SAMA 比賽',
  PAMA_OLIMPIC_PAY_PARTICIPATE: '付費參加 PAMA 比賽',

  // Competition Status
  OLIMPIC_REGISTERED: '你已報名比賽',
  OLIMPIC_STARTS: '訂於',
  FROM: ' ',
  TO: '至',
  OLIMPIC_COMPLETED: '比賽已完成',

  // Diplomas
  DIPLOMS: '獎狀',
  DIPLOMA: '獎狀',
  DIPLOM_FOR_CENTER: '中心獎狀',
  DIPLOM_FOR_TEACHER: '教師獎狀',
  CHANGE_TEXT: '編輯文字',
  ENTER_TEXT: '輸入文字',
  YEARS: '歲',

  // Validation
  PAYMENT_PARAM_VALIDATION: '請選擇產品',
  PAYMENT_PARAMS_VALIDATION: '請選擇產品和學生',
  EXAM_REQUIRE_PAYMENT: '需要付費才能參加考試',

  // Scores
  OVERALL_SCORE: '總分',
  SCORE_O: '分數',
  SCORE_MAX: '最高分',
  STAGE: '階段',
  stage_num: '階段 {stage}',

  // Print Restrictions
  OLIMPIC_PRINT_CLOSED_FOR_TEACHER: '需要至少一位已付費的學生才能列印比賽題目',
  OLIMPIC_PRINT_CLOSED_FOR_STUDENT: '需要付費使用平台才能列印比賽題目',

  // Participants
  PARTICIPANTS: '參賽者',
  OFFLINE_OLIMPIC_PARTICIPANTS: '實體比賽參賽者',
  PARTICIPANT_OVZ: '身心障礙參賽者',
  REQUIRED_OVZ_DOCUMENT: '請透過 Telegram 提交符合協會規定的身心障礙證明',
  OVZ: '身心障礙',
  ASSOCIATION: '協會',
  export: '匯出',

  // Companion
  MAINTAINER: '陪同者',
  TSHORT: 'T 恤',
  TSHIRT_SIZE: 'T 恤尺寸',
  MAINTAINERS_COUNT: '陪同者人數',
  MAINTAINERS_LIMIT_FOR_1_PARTICIPANT: '每位參賽者的陪同者門票上限',

  // Edit Messages
  OLIMPIC_PARTICIPANT_SUCCESS_EDIT_MESSAGE: '比賽參賽者資料更新成功',
  OLIMPIC_PARTICIPANTS_SUCCESS_EDIT_MESSAGE: '比賽參賽者資料更新成功',
  PARTICIPANT_NOT_FOUND: '找不到參賽者',

  // Access Requirements
  PAID: '已付費',
  PAID_6_MONTHS: '要求 6 個月付費',
  REQUIRED_6_MONTHS_OLIMPIC:
    '比賽僅供活躍使用者參加。您需要在過去 6 個月內已付費使用平台。您現在可以購買接下來 6 個月的存取權。請詳閱比賽規章。',
  PAID_9_MONTHS: '要求 9 個月付費',
  REQUIRED_9_MONTHS_OLIMPIC:
    '比賽僅供活躍使用者參加。您需要在過去 9 個月內已付費使用平台。您現在可以購買「1 年訂閱」。請詳閱比賽規章。',

  // Delete Confirmations
  CONFIRM_DELETE_USER: '警告！確定要刪除此使用者嗎？此操作無法復原！',
  CONFIRM_DELETE_USERS: '警告！確定要刪除 {count} 位使用者嗎？此操作無法復原！',
  CONFIRM_ALIVE_USER: '確定要恢復此使用者嗎？',
  DELETED_USERS_TITLE: '已刪除的使用者',
  CONFIRM_DELETE_OLIMPIC: '確定要刪除此比賽嗎？',
  CONFIRM_CLEAR_RESULT: '確定要重設此參賽者的成績嗎？',
  CONFIRM_DELETE_OFFLINE_PARTICIPANT: '確定要刪除此參賽者的門票及其陪同者嗎？',
  CONFIRM_DELETE_ONLINE_PARTICIPANT: '確定要刪除此參賽者嗎？',

  // Competition Encouragement
  OLIMPIC_ENCOURAGE:
    '祝你好運並獲得勝利！點擊「開始比賽」按鈕後，你將無法返回，只有 1 次機會。整個比賽過程必須從頭到尾錄影。請將影片上傳至任何雲端儲存空間並附上連結。',
  OLIMPIC_LINK_WARN:
    '影片連結為必填，否則獎項名次將被降低！請確保影片的存取權限已開啟。你也可以在比賽結束後、成績審核前附上連結',
  LINK_NOTICE:
    '連結可以稍後在「比賽」分頁中附上。請注意：沒有影片，成績將不被計算。',
  OLIMPIC_CONGRATS: '恭喜你，你的嘗試已完成',
  END: '結束',
  BOLD: '粗體',
  custom_text: '文字',

  // Champion / Competitor
  CHAMPION: '冠軍',
  CHAMPION_EN: 'Champion',
  COMPETITOR_EN: 'Competitor',
  COMPETITOR: '參賽者',

  // Math Categories (short labels for UI)
  AddMENTAL: '心算加減法',
  AddABACUS: '算盤加減法',
  Card: '珠像',
  MultiABACUS: '算盤乘法',
  DivisionABACUS: '算盤除法',
  Multi: '乘法表',
  Division: '除法表',
  MultiMENTAL: '心算乘法',
  DivisionMENTAL: '心算除法',
  MultiDivision: '乘除法表',

  // Math Categories (English labels — always English for diplomas)
  AddMENTALen: 'Mental addition and subtraction',
  AddABACUSen: 'Addition and subtraction on the Abacus',
  Carden: 'Flash cards',
  MultiABACUSen: 'Multiplication on the Abacus',
  DivisionABACUSen: 'Division on the Abacus',
  Multien: 'Multiplication table',
  Divisionen: 'Division table',
  MultiMENTALen: 'Mental multiplication',
  DivisionMENTALen: 'Mental division',
  MultiDivisionen: 'Multiplication and division table',

  // Competition Management
  OPEN_TICKET_SALES: '開放售票',
  SHOW_RESULTS: '顯示成績',
  SHOW_DIPLOMS: '顯示獎狀',
  ACTIVE_SIMULATION: '啟用模擬',
  SHOW_RATING: '顯示排行',
  SHOW_PRINT: '啟用題目列印',
  ACTIONS: '操作',
  ACTION: '操作',
  DIPLOM_EN: '獎狀（英文）',
  DIPLOM_RU: '獎狀（俄文）',
  AFTER: '之後',
  DICTANT_SETTINGS: '聽寫設定',
  OLIMPIC_SUCCESS_RESULT: '比賽成績儲存成功',
  PHONE_INVALID: '電話號碼無效或未填寫。',

  // Exam Statuses
  EXAM_NEW: '考試已建立',
  EXAM_FINISHED: '考試已完成',
  EXAM_IN_PROCESS: '考試進行中',
  EXAM_ARCHIVE: '考試已封存',
  EXAM_SUCCESSFUL: '考試通過',
  EXAM_SUCCESSFUL_RUN: '你已通過考試，請等待證書',
  EXAM_FAILURE: '考試未通過',
  EXAM_FAILURE_RUN: '你未通過考試，請繼續練習',
  EXAM_NOT_REQUIRED_NUMBER_OF_POINTS: '使用者未達到所需分數（每項任務 ≥70 分）',
  EXAM_TEACHER_DNOT_RUN_CERTIFICATION_FOR_SAMA:
    '教師無法發放 SAMA 證書——僅限管理員',
  EXAM_TEACHER_DNOT_RUN_CERTIFICATION_FOR_PAMA:
    '教師無法發放 PAMA 證書——僅限管理員',
  EXAM_TEACHER_DNOT_RUN_CERTIFICATION: '教師無法發放證書——僅限管理員',

  // Homework Statuses
  new: '新',
  process: '進行中',
  success: '已完成',
  overfill: '超額完成',
  left_tasks: '剩餘',

  // Motivational Phrases
  HIT_1: '讓老師刮目相看！',
  HIT_2: '讓所有人驚嘆！',
  HIT_3: '更上一層樓！',
  HIT_4: '你還能做得更好嗎？',

  // Training Modes
  FLASH_CARD: '閃卡',
  FLASH_BATTLE: '閃卡對戰',
  ANZAN: '暗算',
  ANZAN_VIRTUAL: '虛擬暗算',
  SOUND: '聲音',
  AUTOREPEAT: '自動重複',
  DICTANT: '聽寫',
  SHOW_ANSWERS: '聽寫答案',
  SHOW_EXAMPLES: '顯示題目',
  HIDE_EXAMPLES: '隱藏題目',
  SHOW_ANSWER: '顯示答案',
  HIDE_ANSWER: '隱藏答案',
  EXAMPLE: '題目',
  max_discharge: '最大答案位數（大魚）',
  min_discharge: '最小答案位數（小魚）',
  ABACUS_FULL: '顯示完整算盤',
  ABACUS_ALIGN: '從算盤中央計算',

  // Modals
  UPDATE_MODAL_TITLE: '親愛的使用者！',
  UPDATE_MODAL_MESSAGE:
    '我們已更新平台！修復了一些問題並新增了新功能。請重新整理頁面以開始使用！',
  UPDATE: '更新',
  SKIP: '稍後再說',

  // Progress Messages
  EXAMPLE_EXECUTED_CONGRATS: '恭喜你，這個任務已完成！',
  TIME_OVERWRITE_WARNING:
    '請注意：在舒爾特方格訓練中，每個新結果都會覆蓋之前的結果，即使完成時間增加了。',
  GO_NEXT_EXAMPLES: '前往其他任務',
  GO_LINK: '前往',
  CONTINUE_EXAMPLE: '繼續此任務',

  // Teamwork
  TEAMWORK_USERS_INVITE_TITLE: '邀請目前線上的學生！',
  TEAMWORK_INVITE_TITLE: '{user} 邀請你加入課程！',
  INVITE_ACTION: '邀請',
  INVITED: '已邀請',
  ACCEPT: '接受',
  DECLINE: '拒絕',
  TEAMWORK_KICK_TITLE: '確定要將 {user} 從課程中移除嗎？',
  'teamwork.user.joined': '學生已加入',
  'teamwork.user.left': '學生已離開訓練工具',

  // Painter
  CLEAR_DRAWING: '清除',
  SIZE: '大小',
  COLOR: '顏色',
  PIXELS_SHORT: 'px',

  // Referral Clues
  S_REFERRAL_CLUE:
    '分享你的連結！當朋友註冊並付費購買存取權時，你將獲得 25 U 幣',
  T_TO_S_REFERRAL_CLUE_1:
    '分享給你的學生和其他人！當他們註冊並付費時，你將獲得 25 U 幣！',
  T_TO_S_REFERRAL_CLUE_2: '注意：',
  T_TO_S_REFERRAL_CLUE_3: '你仍需透過「名錄/學生/從名單新增」來連結你的學生',
  T_TO_T_REFERRAL_CLUE:
    '推薦其他教師！當他們註冊並連結已付費的學生時，你將獲得 50 U 幣！',

  // System Clues
  RATING_CLUE: '排行榜每天 00:00（莫斯科時間）更新',
  S_ACCESS_CLUE: '付款後立即獲得完整平台存取權',
  S_CERT_EXAM_CLUE: '付費購買檢定考試後，請通知你的教師或管理員安排考試',
  OLIMPIC_PARTICIPATION_CLUE:
    '比賽需要另外付費。模擬和線上參賽僅在平台存取權有效時可用',

  // Balance Clues
  BALANCE_CLUE_1: '所有價格均以 U 幣計價（1 U 幣 = 1 盧布）。',
  BALANCE_CLUE_2: '若要購買，請透過「儲值」來加值你的餘額。',
  BALANCE_CLUE_3: '別忘了完成購買以啟用付費功能！',

  // Teacher Access Clues
  T_ACCESS_CLUE_1: '在此購買學生存取權。',
  T_ACCESS_CLUE_2: '付費功能將在購買的期限內立即解鎖。',
  T_ACCESS_CLUE_3: '若要從',
  T_ACCESS_CLUE_4: '已購買的存取權套餐',
  T_ACCESS_CLUE_5: '中付費，請僅選擇「套餐中的 1 個月」！',

  // Certification Clues
  T_CERT_EXAM_CLUE:
    '學生付費後，請在「檢定/考試」中為其建立考試，或聯絡管理員。教師只有在完成培訓後才能參加 UAMAP 考試',
  CERT_EXAM_CLUE_2: '「考試」分頁需要有效的平台存取權',

  // Package Clues
  ACCESS_PACKET_CLUE_1: '優惠的學生存取權（以每位學生計價）。',
  ACCESS_PACKET_CLUE_2: '套餐沒有儲存限制，可以累積。隨時延長學生存取權。',
  ACCESS_PACKET_CLUE_3:
    '在「平台存取權」中的「套餐中的 1 個月（剩餘：...）」查看剩餘餘額',

  // Homework Clues
  NEW_HOMEWORK_CLUE_1: '此處僅顯示目前有效的作業設定。已到期的作業會自動消失。',
  NEW_HOMEWORK_CLUE_2: '編輯任務以避免過度指派。',
  NEW_HOMEWORK_CLUE_3: '已完成的作業會顯示在「待批改」中',
  CREATE_HOMEWORK_CLUE:
    '注意：只有當所有訓練工具都達到所需的題目數量時，作業才會被標記為完成。',
  DAILY_HOMEWORK_CLUE:
    '「每日」設定會每天建立新的作業。未完成的每日作業（沒有「已完成」狀態）不會被儲存。我們提倡正向激勵——不追蹤欠繳作業。',
  DAILY_MAX_HOMEWORK_CLUE: '目前上限：{count} 個每日作業。學生越多，上限越高',
  DEADLINE_HOMEWORK_CLUE: '若要設定長期完成目標，請使用「截止日期」設定',

  // Homework Completion
  COMPLETED_HOMEWORK_CLUE_1:
    '作業在狀態為「已完成」或「超額完成」時標記為完成。',
  COMPLETED_HOMEWORK_CLUE_2:
    '作業完成後的隔天會顯示在此處。學生可以在 24 小時內超額完成。批改時請注意已完成/超額完成的計數器。',
  COMPLETED_HOMEWORK_CLUE_3: '使用星星和評語為作業評分',

  // Exam Requirements
  EXAM_CLUE: '考試過程必須錄影（需要影片）。請附上錄影連結。',
  EXAM_CLUE_2:
    '將影片上傳至雲端儲存空間（Google 雲端硬碟、Yandex Disk 等）並分享連結。',

  // Abacus Interaction
  ABACUS_CLUE: '點擊算盤橫樑可做標記。再次點擊可移除標記。',

  // Competition Management
  CREATE_PARTICIPANT: '建立新參賽者',
  EDIT_PARTICIPANT: '編輯參賽者',
  SELECT_COUNTRY: '選擇國家',
  SELECT_CATEGORY: '選擇類別',
  OLIMPIC_CHOOSE_CATEGORY:
    '如果你之前曾獲獎，請選擇更高的類別。若不遵守規則，可能會被取消資格',
  DELEGATE: '代表',
  CREATE_DELEGATE: '建立新代表',
  EDIT_DELEGATE: '編輯代表',
  SET_PLACE: '指派名次',
  CLEAR_RESULT: '清除成績',

  // Information Sections
  REGULATIONS: '規章',
  INFORMATION: '資訊',
  DIPLOMAS: '獎狀',
  MENTAL: 'Mental',
  SELECT_PLACE: 'Select place',

  // Technical
  SOUND_CLUE: '你的瀏覽器不支援語音合成',

  // Data Table
  'table.no-match': '抱歉，找不到符合的記錄',
  'table.tooltip': '排序',
  'table.next': '下一頁',
  'table.previous': '上一頁',
  'table.rows_per_page': '每頁筆數：',
  'table.display_rows': '/',
  'table.jump_to_page': '前往頁面：',
  'table.search': '搜尋',
  'table.download_csv': '下載',
  'table.print': '列印',
  'table.view_columns': '查看欄位',
  'table.filter_table': '篩選',
  'table.all': '全部',
  'table.filter_title': '篩選',
  'table.reset': '重設',
  'table.title': '顯示欄位',
  'table.title_aria': '顯示/隱藏欄位',
  'table.text': '已選取',
  'table.delete': '刪除',
  'table.delete_aria': '刪除所選列',

  // Products
  'product.type_1.1': '平台存取權（1 個月）',
  'product.type_1.6': '平台存取權（6 個月）',
  'product.type_1.12': '平台存取權（12 個月）',
  'product.type_2.10': '存取權套餐（10 位學生）',
  'product.type_2.25': '存取權套餐（25 位學生）',
  'product.type_2.50': '存取權套餐（50 位學生）',
  'product.type_3.1': '從套餐存取',
  'product.type_4.0': 'PAMA 考試存取權',
  'product.type_5.0': 'UAMAP 考試存取權',
  'product.type_6.0': '線上比賽存取權',
  'product.type_7.0': '實體比賽存取權',
  'product.type_8.0': '陪同者門票',
  'product.type_9.0': 'PAMA 比賽存取權',
  'product.type_10.0': 'PAMA Global 實體比賽存取權',
  'product.type_11.0': '陪同者門票',

  // Exams
  ONLY_MENTAL: '僅心算',

  // Teacher Level Exams
  ABACUS_ARITHMETIC_ADD_TEACHER_LEVEL_1_SECTION_1: '10 題目：3-4D10R 算盤',
  ABACUS_ARITHMETIC_ADD_TEACHER_LEVEL_1_SECTION_2: '20 題目：3D3D',
  ABACUS_ARITHMETIC_ADD_TEACHER_LEVEL_1_SECTION_3: '20 題目：4-5D/2-3D',
  ABACUS_ARITHMETIC_ADD_TEACHER_LEVEL_1_SECTION_4: '10 題目：2D6R',
  ABACUS_ARITHMETIC_ADD_TEACHER_LEVEL_1_SECTION_5: '20 題目：2D1D, 3D/1D',

  ABACUS_ARITHMETIC_ADD_TEACHER_LEVEL_2_SECTION_1: '10 題目：2-3D10R 算盤',
  ABACUS_ARITHMETIC_ADD_TEACHER_LEVEL_2_SECTION_2: '20 題目：2D*2D',
  ABACUS_ARITHMETIC_ADD_TEACHER_LEVEL_2_SECTION_3: '20 題目：3-4D/1D',
  ABACUS_ARITHMETIC_ADD_TEACHER_LEVEL_2_SECTION_4: '10 題目：1D7R',
  ABACUS_ARITHMETIC_ADD_TEACHER_LEVEL_2_SECTION_5: '10 題目：1-2D5R',

  ABACUS_ARITHMETIC_ADD_TEACHER_LEVEL_3_SECTION_1: '50 題目：乘法表',
  ABACUS_ARITHMETIC_ADD_TEACHER_LEVEL_3_SECTION_2: '50 題目：除法表',
  ABACUS_ARITHMETIC_ADD_TEACHER_LEVEL_3_SECTION_3: '20 題目：1-2D10R 算盤',
  ABACUS_ARITHMETIC_ADD_TEACHER_LEVEL_3_SECTION_4: '20 題目：1D6R',

  // Student Level Exams (6-13)
  ABACUS_ARITHMETIC_ADD_LEVEL_6_SECTION_1: '10 題目：3-4D10R 算盤',
  ABACUS_ARITHMETIC_MULTIPLICATION_LEVEL_6_SECTION_2: '20 題目：3D2D',
  ABACUS_ARITHMETIC_DIVISION_LEVEL_6_SECTION_3: '20 題目：3-4D/2-3D',
  ABACUS_ARITHMETIC_ADD_LEVEL_6_SECTION_4: '10 題目：2D4R',
  ABACUS_ARITHMETIC_MULTIPLICATION_LEVEL_6_SECTION_5: '20 題目：2-3D1D',

  ABACUS_ARITHMETIC_ADD_LEVEL_7_SECTION_1: '10 題目：2-3D10R 算盤',
  ABACUS_ARITHMETIC_MULTIPLICATION_LEVEL_7_SECTION_2: '20 題目：2D*2D',
  ABACUS_ARITHMETIC_DIVISION_LEVEL_7_SECTION_3: '20 題目：3-4D/1D',
  ABACUS_ARITHMETIC_ADD_LEVEL_7_SECTION_4: '10 題目：1D7R',
  ABACUS_ARITHMETIC_ADD_LEVEL_7_SECTION_5: '10 題目：1-2D5R',

  ABACUS_ARITHMETIC_ADD_LEVEL_8_SECTION_1: '10 題目：2D10R 算盤',
  ABACUS_ARITHMETIC_MULTIPLICATION_LEVEL_8_SECTION_2: '20 題目：3D*1D',
  ABACUS_ARITHMETIC_DIVISION_LEVEL_8_SECTION_3: '20 題目：2-3D/1D',
  ABACUS_ARITHMETIC_ADD_LEVEL_8_SECTION_4: '10 題目：1D6R',
  ABACUS_ARITHMETIC_ADD_LEVEL_8_SECTION_5: '10 題目：1-2D4R',

  ABACUS_ARITHMETIC_ADD_LEVEL_9_SECTION_1: '20 題目：乘法表',
  ABACUS_ARITHMETIC_ADD_LEVEL_9_SECTION_2: '10 題目：1-2D10R 算盤',
  ABACUS_ARITHMETIC_ADD_LEVEL_9_SECTION_3: '10 題目：2D4R 算盤',
  ABACUS_ARITHMETIC_ADD_LEVEL_9_SECTION_4: '10 題目：1D4R',
  ABACUS_ARITHMETIC_ADD_LEVEL_9_SECTION_5: '10 題目：1D5R',

  ABACUS_ARITHMETIC_ADD_LEVEL_10_SECTION_1: '20 題目：10 的合成',
  ABACUS_ARITHMETIC_ADD_LEVEL_10_SECTION_2: '10 題目：1D10R 算盤',
  ABACUS_ARITHMETIC_ADD_LEVEL_10_SECTION_3: '10 題目：2D4RF5 算盤',
  ABACUS_ARITHMETIC_ADD_LEVEL_10_SECTION_4: '10 題目：1D5RF5',
  ABACUS_ARITHMETIC_ADD_LEVEL_10_SECTION_5: '10 題目：1D4RF10',

  ABACUS_ARITHMETIC_ADD_LEVEL_11_SECTION_1: '20 題目：10 的合成',
  ABACUS_ARITHMETIC_ADD_LEVEL_11_SECTION_2: '10 題目：1D8RF10 算盤',
  ABACUS_ARITHMETIC_ADD_LEVEL_11_SECTION_3: '10 題目：2D3RF5 算盤',
  ABACUS_ARITHMETIC_ADD_LEVEL_11_SECTION_4: '10 題目：1D5RNF',
  ABACUS_ARITHMETIC_ADD_LEVEL_11_SECTION_5: '10 題目：1D3RF5',

  ABACUS_ARITHMETIC_ADD_LEVEL_12_SECTION_1: '20 題目：10 的合成',
  ABACUS_ARITHMETIC_ADD_LEVEL_12_SECTION_2: '10 題目：1D6RF5 算盤',
  ABACUS_ARITHMETIC_ADD_LEVEL_12_SECTION_3: '10 題目：2D3RNF 算盤',
  ABACUS_ARITHMETIC_ADD_LEVEL_12_SECTION_4: '10 題目：1D4RNF',
  ABACUS_ARITHMETIC_ADD_LEVEL_12_SECTION_5: '20 題目：2D 閃卡',

  ABACUS_ARITHMETIC_ADD_LEVEL_13_SECTION_1: '20 題目：5 的合成',
  ABACUS_ARITHMETIC_ADD_LEVEL_13_SECTION_2: '10 題目：1D5RNF 算盤',
  ABACUS_ARITHMETIC_ADD_LEVEL_13_SECTION_3: '10 鏡像題目：2D3RNF 算盤',
  ABACUS_ARITHMETIC_ADD_LEVEL_13_SECTION_4: '10 題目：1D3RNF',
  ABACUS_ARITHMETIC_ADD_LEVEL_13_SECTION_5: '20 題目：1D 閃卡',

  // UI/Management
  VISIBILITY: '顯示狀態',
  HISTORY_TITLE: '交易記錄',
  OLIMP_PURCHASES: '比賽購買記錄',
  CREATOR: '建立者',

  // News
  files: '檔案',
  fullscreen: '全螢幕',
  DROP_FILES: '點擊、拖曳或貼上檔案以上傳...',
  NEWS_TYPE: '消息類別',
  DEFAULT_NEWS: '一般',
  UPDATE_NEWS: '更新',
  FEATHERS_NEWS: '羽毛',
  WHITE_NEWS: '白色',
  BLUE_NEWS: '藍色',
  RED_NEWS: '紅色',
  YELLOW_NEWS: '黃色',
  GREEN_NEWS: '綠色',
  PURPLE_NEWS: '紫色',
  NEWS_UNCHECKED: '有什麼新消息？',
  NEWS_CHECKED: '已讀',
  NEWS_CHECKED_ALL: '您已掌握所有最新消息！繼續保持！',
  NEWS_HEADER: '最新消息！',
  NEWS_EMPTY: '目前沒有新消息。請密切關注！',
  FIRST_PAYMENT: '首次付款',
  INVITED_STUDENTS_2: '推薦的學生',
  INVITED_TEACHERS_2: '推薦的教師',

  // Groups/Auth
  GROUP_MEMBERS: '班級成員',
  RESTORE_PASSWORD: '重設密碼',
  DUPLICATES_TITLE: '這是您的帳號嗎？',
  DIRECTORY_DUPLICATES_TITLE: '可能的重複項目',
  REGISTER_NEW: '註冊新帳號',

  /// /////////////////////////////
  DELETE_CONFIRM: '確認刪除',

  // Nav
  'nav.burger': '選單',
  'nav.ru': '俄文',
  'nav.en': '英文',
  'nav.signin': '登入',
  'nav.signup': '註冊',
  'nav.forgot_password': '忘記密碼？',
  'nav.create': '建立帳號',
  'nav.im_teacher': '我是教師',
  'nav.im_student': '我是學生',
  'nav.register_modal_title': '您要以什麼身分註冊？',

  // Sidebar
  'sidebar.settings': '設定',
  'sidebar.change_password': '變更密碼',
  'sidebar.logout': '登出',
  'sidebar.homeworks.await': '待辦作業',
  'sidebar.homeworks.check': '待批改',
  'sidebar.homeworks.history': '作業記錄',

  // Register forms
  REGISTER_AS: '您想以什麼身分在平台上註冊？',
  REGISTER_AS_PARENT: '學生家長',
  REGISTER_AS_TEACHER: '教師',
  // ACHIEVEMENTS - Student
  'achievement.student.first_homework.title': '好的開始！',
  'achievement.student.first_homework.desc': '你完成了第一份作業——繼續加油！',
  'achievement.student.2_homeworks_per_day.title': '雙倍樂趣！',
  'achievement.student.2_homeworks_per_day.desc':
    '今天已經是第二份作業了——勢不可擋！',
  'achievement.student.homeworks_for_week_comleted.title': '一帆風順！',
  'achievement.student.homeworks_for_week_comleted.desc':
    '太棒了！你已經連續一週完成所有作業了！',
  'achievement.student.homeworks_for_month_comleted.title': '任務達成',
  'achievement.student.homeworks_for_month_comleted.desc':
    '你的毅力令人欽佩！你已經連續一個月完成所有作業了！',
  'achievement.student.10_homeworks_completed.title': '小而強大！',
  'achievement.student.10_homeworks_completed.desc':
    '太棒了！你已在平台上完成了 10 份作業。',
  'achievement.student.50_homeworks_completed.title': '成果展現！',
  'achievement.student.50_homeworks_completed.desc':
    '太棒了！你已在平台上完成了 50 份作業。',
  'achievement.student.100_homeworks_completed.title': '沒有任何事能阻擋我！',
  'achievement.student.100_homeworks_completed.desc':
    '太棒了！你已在平台上完成了 100 份作業。',
  'achievement.student.500_homeworks_completed.title': '無限還不夠！',
  'achievement.student.500_homeworks_completed.desc':
    '太厲害了！你已在平台上完成了 500 份作業。',
  'achievement.student.set_avatar.title': '笑一個！',
  'achievement.student.set_avatar.desc': '設定或更換個人檔案頭像的獎勵',
  'achievement.student.first_olimpic.title': '試一試吧！',
  'achievement.student.first_olimpic.desc': '恭喜你參加了第一場比賽！',
  'achievement.student.olimpic_prize_place.title': '獎品歸我！',
  'achievement.student.olimpic_prize_place.desc': '恭喜你在比賽中獲得獎項！',
  'achievement.student.olimpic_first_place.title': '最棒的！',
  'achievement.student.olimpic_first_place.desc': '恭喜你在比賽中獲得第一名！',
  'achievement.student.first_exam_access.title': '我準備好了！',
  'achievement.student.first_exam_access.desc': '你參加了第一場考試——做得好！',
  'achievement.student.access_3_month.title': '一起前進！',
  'achievement.student.access_3_month.desc':
    '太棒了！你已經連續 3 個月和我們一起學習了。',
  'achievement.student.access_6_month.title': '六個月如一日',
  'achievement.student.access_6_month.desc':
    '太棒了！你已經連續 6 個月和我們一起學習了。',
  'achievement.student.access_12_month.title': '我不會回頭...',
  'achievement.student.access_12_month.desc':
    '太棒了！你已經和我們一起學習了一整年。',
  'achievement.student.student_try_uamap.title': '我不想只是看！',
  'achievement.student.student_try_uamap.desc': '第一次模擬 UAMAP 考試的獎勵',
  'achievement.student.student_try_sama_mental.title': '心算之旅開始了...',
  'achievement.student.student_try_sama_mental.desc':
    '第一次模擬 PAMA GLOBAL 心算考試的獎勵',
  'achievement.student.student_try_sama_abacus.title': '一切從算盤開始...',
  'achievement.student.student_try_sama_abacus.desc':
    '第一次模擬 PAMA GLOBAL 算盤考試的獎勵',

  // UAMAP Medals (Levels 6-13)
  'achievement.student.uamap_13.title': 'UAMAP 獎牌 13 級',
  'achievement.student.uamap_13.desc': '恭喜你通過了 UAMAP 13 級考試！',
  'achievement.student.uamap_12.title': 'UAMAP 獎牌 12 級',
  'achievement.student.uamap_12.desc': '恭喜你通過了 UAMAP 12 級考試！',
  'achievement.student.uamap_11.title': 'UAMAP 獎牌 11 級',
  'achievement.student.uamap_11.desc': '恭喜你通過了 UAMAP 11 級考試！',
  'achievement.student.uamap_10.title': 'UAMAP 獎牌 10 級',
  'achievement.student.uamap_10.desc': '恭喜你通過了 UAMAP 10 級考試！',
  'achievement.student.uamap_9.title': 'UAMAP 獎牌 9 級',
  'achievement.student.uamap_9.desc': '恭喜你通過了 UAMAP 9 級考試！',
  'achievement.student.uamap_8.title': 'UAMAP 獎牌 8 級',
  'achievement.student.uamap_8.desc': '恭喜你通過了 UAMAP 8 級考試！',
  'achievement.student.uamap_7.title': 'UAMAP 獎牌 7 級',
  'achievement.student.uamap_7.desc': '恭喜你通過了 UAMAP 7 級考試！',
  'achievement.student.uamap_6.title': 'UAMAP 獎牌 6 級',
  'achievement.student.uamap_6.desc': '恭喜你通過了 UAMAP 6 級考試！',

  // PAMA GLOBAL Abacus Order (Levels 1-12)
  'achievement.student.sama_abacus_12.title': 'PAMA GLOBAL 算盤勳章 12 級',
  'achievement.student.sama_abacus_12.desc':
    '恭喜你通過了 PAMA GLOBAL 算盤 12 級考試！',
  'achievement.student.sama_abacus_11.title': 'PAMA GLOBAL 算盤勳章 11 級',
  'achievement.student.sama_abacus_11.desc':
    '恭喜你通過了 PAMA GLOBAL 算盤 11 級考試！',
  'achievement.student.sama_abacus_10.title': 'PAMA GLOBAL 算盤勳章 10 級',
  'achievement.student.sama_abacus_10.desc':
    '恭喜你通過了 PAMA GLOBAL 算盤 10 級考試！',
  'achievement.student.sama_abacus_9.title': 'PAMA GLOBAL 算盤勳章 9 級',
  'achievement.student.sama_abacus_9.desc':
    '恭喜你通過了 PAMA GLOBAL 算盤 9 級考試！',
  'achievement.student.sama_abacus_8.title': 'PAMA GLOBAL 算盤勳章 8 級',
  'achievement.student.sama_abacus_8.desc':
    '恭喜你通過了 PAMA GLOBAL 算盤 8 級考試！',
  'achievement.student.sama_abacus_7.title': 'PAMA GLOBAL 算盤勳章 7 級',
  'achievement.student.sama_abacus_7.desc':
    '恭喜你通過了 PAMA GLOBAL 算盤 7 級考試！',
  'achievement.student.sama_abacus_6.title': 'PAMA GLOBAL 算盤勳章 6 級',
  'achievement.student.sama_abacus_6.desc':
    '恭喜你通過了 PAMA GLOBAL 算盤 6 級考試！',
  'achievement.student.sama_abacus_5.title': 'PAMA GLOBAL 算盤勳章 5 級',
  'achievement.student.sama_abacus_5.desc':
    '恭喜你通過了 PAMA GLOBAL 算盤 5 級考試！',
  'achievement.student.sama_abacus_4.title': 'PAMA GLOBAL 算盤勳章 4 級',
  'achievement.student.sama_abacus_4.desc':
    '恭喜你通過了 PAMA GLOBAL 算盤 4 級考試！',
  'achievement.student.sama_abacus_3.title': 'PAMA GLOBAL 算盤勳章 3 級',
  'achievement.student.sama_abacus_3.desc':
    '恭喜你通過了 PAMA GLOBAL 算盤 3 級考試！',
  'achievement.student.sama_abacus_2.title': 'PAMA GLOBAL 算盤勳章 2 級',
  'achievement.student.sama_abacus_2.desc':
    '恭喜你通過了 PAMA GLOBAL 算盤 2 級考試！',
  'achievement.student.sama_abacus_1.title': 'PAMA GLOBAL 算盤勳章 1 級',
  'achievement.student.sama_abacus_1.desc':
    '恭喜你通過了 PAMA GLOBAL 算盤 1 級考試！',

  // PAMA GLOBAL Mental Crown (Levels 1-12)
  'achievement.student.sama_mental_12.title': 'PAMA GLOBAL 心算皇冠 12 級',
  'achievement.student.sama_mental_12.desc':
    '恭喜你通過了 PAMA GLOBAL 心算 12 級考試！',
  'achievement.student.sama_mental_11.title': 'PAMA GLOBAL 心算皇冠 11 級',
  'achievement.student.sama_mental_11.desc':
    '恭喜你通過了 PAMA GLOBAL 心算 11 級考試！',
  'achievement.student.sama_mental_10.title': 'PAMA GLOBAL 心算皇冠 10 級',
  'achievement.student.sama_mental_10.desc':
    '恭喜你通過了 PAMA GLOBAL 心算 10 級考試！',
  'achievement.student.sama_mental_9.title': 'PAMA GLOBAL 心算皇冠 9 級',
  'achievement.student.sama_mental_9.desc':
    '恭喜你通過了 PAMA GLOBAL 心算 9 級考試！',
  'achievement.student.sama_mental_8.title': 'PAMA GLOBAL 心算皇冠 8 級',
  'achievement.student.sama_mental_8.desc':
    '恭喜你通過了 PAMA GLOBAL 心算 8 級考試！',
  'achievement.student.sama_mental_7.title': 'PAMA GLOBAL 心算皇冠 7 級',
  'achievement.student.sama_mental_7.desc':
    '恭喜你通過了 PAMA GLOBAL 心算 7 級考試！',
  'achievement.student.sama_mental_6.title': 'PAMA GLOBAL 心算皇冠 6 級',
  'achievement.student.sama_mental_6.desc':
    '恭喜你通過了 PAMA GLOBAL 心算 6 級考試！',
  'achievement.student.sama_mental_5.title': 'PAMA GLOBAL 心算皇冠 5 級',
  'achievement.student.sama_mental_5.desc':
    '恭喜你通過了 PAMA GLOBAL 心算 5 級考試！',
  'achievement.student.sama_mental_4.title': 'PAMA GLOBAL 心算皇冠 4 級',
  'achievement.student.sama_mental_4.desc':
    '恭喜你通過了 PAMA GLOBAL 心算 4 級考試！',
  'achievement.student.sama_mental_3.title': 'PAMA GLOBAL 心算皇冠 3 級',
  'achievement.student.sama_mental_3.desc':
    '恭喜你通過了 PAMA GLOBAL 心算 3 級考試！',
  'achievement.student.sama_mental_2.title': 'PAMA GLOBAL 心算皇冠 2 級',
  'achievement.student.sama_mental_2.desc':
    '恭喜你通過了 PAMA GLOBAL 心算 2 級考試！',
  'achievement.student.sama_mental_1.title': 'PAMA GLOBAL 心算皇冠 1 級',
  'achievement.student.sama_mental_1.desc':
    '恭喜你通過了 PAMA GLOBAL 心算 1 級考試！',

  // ACHIEVEMENTS - Teacher
  'achievement.teacher.first_student_exam_completed.title': '第一個完成了！',
  'achievement.teacher.first_student_exam_completed.desc': '1 位學生通過了考試',
  'achievement.teacher.10_student_exams_completed.title': '團隊建立者！',
  'achievement.teacher.10_student_exams_completed.desc': '10 位學生通過了考試',
  'achievement.teacher.50_student_exams_completed.title': '導師',
  'achievement.teacher.50_student_exams_completed.desc': '50 位學生通過了考試',
  'achievement.teacher.homeworks_for_week_comleted.title': '樹立榜樣',
  'achievement.teacher.homeworks_for_week_comleted.desc':
    '恭喜！你的學生連續一週完成了所有作業！',
  'achievement.teacher.olimpic_prize_1.title': '分享知識',
  'achievement.teacher.olimpic_prize_1.desc':
    '恭喜！你的一位學生在比賽中獲得了獎項！',
  'achievement.teacher.olimpic_prize_3.title': '師父',
  'achievement.teacher.olimpic_prize_3.desc':
    '恭喜！你的 3 位學生在比賽中獲得了獎項！',
  'achievement.teacher.olimpic_prize_5.title': '智慧教師',
  'achievement.teacher.olimpic_prize_5.desc':
    '恭喜！你的 5 位學生在比賽中獲得了獎項！',
  'achievement.teacher.10_homeworks_created.title': '沒有時間休息！',
  'achievement.teacher.10_homeworks_created.desc':
    '不錯！你已經給學生指派了 10 份作業。',
  'achievement.teacher.100_homeworks_created.title': '我精通我的專業！',
  'achievement.teacher.100_homeworks_created.desc':
    '不錯！你已經給學生指派了 100 份作業。',
  'achievement.teacher.500_homeworks_created.title': '多多益善！',
  'achievement.teacher.500_homeworks_created.desc':
    '不錯！你已經給學生指派了 500 份作業。',
  'achievement.teacher.referal_created_student_1.title': '(+1)',
  'achievement.teacher.referal_created_student_1.desc':
    '恭喜！你邀請了一位新學生加入平台！',
  'achievement.teacher.referal_created_student_5.title': '團結力量大',
  'achievement.teacher.referal_created_student_5.desc':
    '恭喜！你邀請了 5 位學生加入平台！',
  'achievement.teacher.referal_created_student_10.title': '我們是一個團隊！',
  'achievement.teacher.referal_created_student_10.desc':
    '恭喜！你邀請了 10 位學生加入平台！',
  'achievement.teacher.referal_created_teacher_1.title': '不再孤單！',
  'achievement.teacher.referal_created_teacher_1.desc':
    '恭喜！你邀請了一位新教師加入平台！',
  'achievement.teacher.referal_created_teacher_3.title': '都是一家人！',
  'achievement.teacher.referal_created_teacher_3.desc':
    '恭喜！你邀請了 3 位教師加入平台！',
  'achievement.teacher.referal_created_teacher_5.title': '我愛我的工作！',
  'achievement.teacher.referal_created_teacher_5.desc':
    '恭喜！你邀請了 5 位教師加入平台！',
  'achievement.teacher.pay_for_student_access.title': '投資未來',
  'achievement.teacher.pay_for_student_access.desc':
    '你剛剛為學生付費了平台訂閱——這是你的獎勵！',
  'achievement.teacher.pay_for_student_olimpic.title': '展現關懷',
  'achievement.teacher.pay_for_student_olimpic.desc':
    '你剛剛為學生付費了比賽參賽——這是你的獎勵！',
  'achievement.teacher.topup_account.title': '遲早派上用場！',
  'achievement.teacher.topup_account.desc':
    '你已經儲值了帳戶——享受一份小禮物吧！',
  'achievement.teacher.set_avatar.title': '笑一個！',
  'achievement.teacher.set_avatar.desc': '設定或更換個人檔案頭像的獎勵',
  'achievement.teacher.complete_profile.title': '我們的一員！',
  'achievement.teacher.complete_profile.desc': '填寫所有個人檔案欄位的獎勵',
  'achievement.teacher.uamap_1.title': 'UAMAP 證書 1 級',
  'achievement.teacher.uamap_1.desc': '恭喜你通過了 UAMAP 1 級考試',
  'achievement.teacher.uamap_2.title': 'UAMAP 證書 2 級',
  'achievement.teacher.uamap_2.desc': '恭喜你通過了 UAMAP 2 級考試',
  'achievement.teacher.uamap_3.title': 'UAMAP 證書 3 級',
  'achievement.teacher.uamap_3.desc': '恭喜你通過了 UAMAP 3 級考試',
  'achievement.teacher.sama_3.title': 'PAMA GLOBAL 3 顆星',
  'achievement.teacher.sama_3.desc': '恭喜！你在 PAMA GLOBAL 獲得了 3 顆星',
  'achievement.teacher.sama_5.title': 'PAMA GLOBAL 2 顆星',
  'achievement.teacher.sama_5.desc': '恭喜！你在 PAMA GLOBAL 獲得了 2 顆星',
  'achievement.teacher.sama_7.title': 'PAMA GLOBAL 1 顆星',
  'achievement.teacher.sama_7.desc': '恭喜！你在 PAMA GLOBAL 獲得了 1 顆星',
  // Other / General
  SOUND_ON: '開',
  DAILY: '每日',
  COMPLETE_BY: '完成截止日',
  SPECIFIC_DAYS: '指定日期',
  SPECIFIC_DAYS_MULTIPLE: '指定日期（可選擇多個日期）',
  MONTHS_LIST:
    '一月,二月,三月,四月,五月,六月,七月,八月,九月,十月,十一月,十二月',
  MONTHS_SHORT: '1月,2月,3月,4月,5月,6月,7月,8月,9月,10月,11月,12月',
  WEEKDAYS_LONG: '星期日,星期一,星期二,星期三,星期四,星期五,星期六',
  WEEKDAYS_SHORT: '日,一,二,三,四,五,六',
  NEXT_MONTH: '下個月',
  PREVIOUS_MONTH: '上個月',
  GENDER_MALE: '男',
  GENDER_FEMALE: '女',
  THEME_STANDARD: '標準',
  THEME_STANDARD_DESC: '所有使用者皆可使用的佈景主題',
  THEME_UNIQUE: '獨特',
  THEME_UNIQUE_DESC: '可用魔法羽毛兌換的佈景主題',
  BRAND_THEME: '品牌主題',
  ABACUS_COLOR_CHOICE: '你可以在這裡選擇算盤珠子的顏色',
  EGYPT_THEME_DESC:
    '沉浸在古埃及的神秘氛圍中，金字塔、法老和隱藏的寶藏等著你！',
  INSTALL: '使用',
  OWL_GREETING: '你好，我的名字叫尤妮貓頭鷹',
  CONFIGURE_TRAINER: '設定訓練工具',
  CHOOSE_TASK_TEXT: '選擇合適的任務，用你的成績讓我驚艷吧',
  QUICK_START: '快速開始',
  QUICK_START_DESC: '點擊立即以隨機設定開始訓練',

  // Schulte Table
  TABLE_SIZE: '表格大小',
  NUMBER_DIGITS: '數字位數',
  SHUFFLE_ON_CLICK: '點擊時重新排列',
  CENTER_DOT: '中心點',
  SYMBOL_ORDER: '符號順序',
  TABLE_TYPE: '表格類型',
  DIRECT_ORDER: '正序',
  REVERSE_ORDER: '逆序',
  RANDOM_ORDER: '隨機',
  NUMBERS: '數字',
  SOUND_VOLUME: '音量',
  FIND_SYMBOL: '找出符號',

  // Other
  DIGIT_RANGE: '數字範圍',
  FOR_WHOM: '適用對象',
  REDUCE_TABLE: '縮小表格',

  // Owl success phrases (correct answers)
  OWL_SUCCESS_1: '穩穩過關',
  OWL_SUCCESS_2: '太棒了！',
  OWL_SUCCESS_3: '哈，小菜一碟',
  OWL_SUCCESS_4: '你超厲害的！',
  OWL_SUCCESS_5: '答對了！',
  OWL_SUCCESS_6: '做得好！',
  OWL_SUCCESS_7: '滿分！',
  OWL_SUCCESS_8: '這也太強了吧！',
  OWL_SUCCESS_9: '你居然做到了！',
  OWL_SUCCESS_10: '知識滿點！',
  OWL_SUCCESS_11: '再來算幾題！',
  OWL_SUCCESS_12: '好順喔！',
  OWL_SUCCESS_13: '輕鬆過關',
  OWL_SUCCESS_14: '好耶！',
  OWL_SUCCESS_15: '太不可思議了！',
  OWL_SUCCESS_16: '你辦到了！',
  OWL_SUCCESS_17: '這答案，全武林最正確！',
  OWL_SUCCESS_18: '人類從沒這麼接近完美過！',

  // Owl failure phrases (wrong answers)
  OWL_FAILED_1: '可惜，不是這個⋯',
  OWL_FAILED_2: '再專心一下下',
  OWL_FAILED_3: '天啊⋯',
  OWL_FAILED_4: '答案不對喔⋯',
  OWL_FAILED_5: '心算需要練習，再來一次',
  OWL_FAILED_6: '方法不太對喔',
  OWL_FAILED_7: '再挑戰一次',
  OWL_FAILED_8: '要再試一次嗎？',
  OWL_FAILED_9: '這次差一點點',
  OWL_FAILED_10: '別難過⋯',
  OWL_FAILED_11: '再試一次⋯',
  OWL_FAILED_12: '沒關係，再想一次',
  OWL_FAILED_13: '再一次⋯',
  OWL_FAILED_14: '多試幾次就會通了！',
  OWL_FAILED_15: '唉唷⋯',
  OWL_FAILED_16: '每次練習都算數',
  OWL_FAILED_17: '一起看看哪裡卡住了',
  OWL_FAILED_18: '下次一定行！',

  // Fullscreen
  FULLSCREEN: '全螢幕',
  EXIT_FULLSCREEN: '離開全螢幕',
  CURRENT_RANK: '你目前的稱號：',

  // Past Winners
  PAST_WINNERS: '歷屆冠軍',
  WINNER_TABLE_CREATE_TITLE: '新增冠軍',
  EDIT_WINNER_TITLE: '編輯冠軍',
  CHOOSE_OLIMPIC_NAME: '選擇比賽',
  CONFIRM_DELETE_WINNER: '確定要刪除冠軍紀錄嗎？',
  FILE_SIZE_ERROR: '請選擇不超過 3MB 的照片',
  FILE_TYPE_ERROR: '檔案類型無效。請上傳圖片（JPEG、PNG 等）',
  SAVE_WINNERS_RESULT: '儲存成績',
  CONFIRM_SAVE_WINNERS: '確定要儲存成績嗎？重要！必須先指派名次。',
  NO_PLACES_WARNING: '未指定名次 0/1！',
  IMPORTANT_FIELDS_LOCKED:
    '姓名、姓氏和出生日期只能修改一次。如需協助，請聯絡管理員。',
  LOGIN_CHANGE_CONFIRM: '在個人資料中修改電子郵件後，你帳號的登入郵件已變更。',

  // Templates
  TEMPLATES: '範本',
  DIPLOMS_RECORDS_TEMPLATES: '獎狀紀錄範本',
  MAIN_TEMPLATE: '預設範本',
  CONFIRM_DELETE_TEMPLATE: '確定要刪除此範本嗎？',
  TEMPLATE_CREATE_TITLE: '建立範本',
  TEMPLATE_EDIT_TITLE: '編輯範本',
  TEMPLATE_SUCCESS_CREATE_MESSAGE: '範本已成功建立',
  TEMPLATE_SUCCESS_EDIT_MESSAGE: '範本已成功更新',
  ADD_STAGE: '新增階段',
  ADD_CATEGORY: '新增類別',
  VARIANT: '計數類型',
  SHORT_RECORD: '簡短紀錄',
  CATEGORY_NAME: '類別名稱',
  CATEGORY_NAME_VALIDATION: '類別名稱只能包含大寫拉丁字母和數字',
  SAMPLES_TYPE: '題目類型',
  TEMPLATE_FORM_TEXT: '選擇獎狀紀錄的範本',

  // Star Rating
  BEST_STUDENTS: '最佳學生',
  RESET_STARS: '重設星星',
  OPEN_ALL: '檢視全部',
  LOADING: '載入中...',
  TAB_IN_SCHOOL: '學校',
  TAB_WITH_TEACHER: '教師',
  TAB_IN_GROUP: '班級',
  NO_RATING_DATA: '排行榜中尚無學生',
  SCHOOL_STAR_RATING: '學校排行',
  GROUPS_STAR_RATING: '班級排行',
  TEACHER_STAR_RATING: '教師排行',
  CONFIRM_RESET_STARS: '確定要重設所有學生的星星嗎？',
  CONFIRM_RESET_SCHOOL_STARS: '確定要重設這些學生的星星嗎？',
  RATING_SCHOOL_MESSAGE: '選擇學生（自己的和教師的）以重設星星',
  NO_TEACHERS: '找不到教師',
  STAR_RATING_CLUE:
    '學生的作業星星。你可以自行決定獎勵學生，藉此提升孩子的學習動機。獎品、總結日期和名次數量由你決定。',
  SETTING_ON: '開',

  // PAMA Specific
  SMGL_USERS_TITLE: 'PAMA 使用者',
  OPERATION_COMPLETED: '作業已成功完成',
  DELETED_COUNT: '已刪除使用者：{count}',
  SHOW_RATING_FOR_UAMAP: '在 UAMAP 顯示排行',
  PAMA_GLOBAL_RATING: 'PAMA Global 排行',
  SHOW_IN_ROW: '並排顯示',
  PAMA_GLOBAL_PRINT: '列印 PAMA Global 題目',
  PAMA_OFFLINE_OLIMPIC: 'PAMA Global 實體',
  PAMA_OFFLINE_FOR_STUDENT: 'PAMA Global 學生實體',
  PAMA_OFFLINE_FOR_TEACHER: 'PAMA Global 教師實體',
  MAINTAINER_PAMA: 'PAMA Global 陪同者',
  PAMA_OFFLINE_PARTICIPANTS: 'PAMA Global 實體參賽者',
  PAMA_OFFLINE_OLIMPIC_PAYMENT: '購買 PAMA GLOBAL 實體比賽參加權',
  MAINTAINER_PAMA_PAYMENT: 'PAMA GLOBAL 實體比賽陪同者',
  PAMA_OFFLINE_OLIMPIC_PAY_PARTICIPATE: '付費參加 PAMA Global 實體比賽',

  // Practice & Companion
  PRACTICE_ON_TAB: '在分頁上練習',
  WITH_ACTIVE_ACCESS: '在我們的平台上擁有有效存取權',
  ACCOMPANY_PARTICIPANT_TEXT: '如果你計劃陪同參賽者，請也為他們購買門票。',
  CURRENT_COMPANION_LIMIT: '目前陪同者上限：',
  COMPANION_SALES_CLOSED: '陪同者門票銷售已結束。',
  PURCHASED_TEXT: '已購買：',
  COMPANION_TICKET_ONE: '張門票',
  COMPANION_TICKET_TWO: '張門票',
  COMPANION_TICKET_FIVE: '張門票',
  OF_COMPANIONS: '位陪同者',
  TICKET_DATA_WARNING: '以下資料將用於建立門票，請檢查是否正確',
  TICKET_EMAIL_DELIVERY_PAMA: '門票將在指定時間內發送至指定的電子郵件地址。',
  TICKET_EMAIL_DELIVERY_OLIMPIC:
    '門票將在 3-5 個工作天內發送至指定的電子郵件地址。如果未收到，請透過以下方式聯絡我們',
  TELEGRAM_LINK_TEXT: 'Telegram',
  EDIT_PROFILE_IF_ERROR: '如有錯誤，請編輯你的個人資料',
  PHOTO_UPLOAD_NOTICE:
    '上傳一張照片（最大 10 MB）到任何雲端儲存空間。複製連結並貼到此處。確保連結具有開放存取權限。',
  SELECT_CATEGORY_PLACEHOLDER: '選擇類別',
  SELECT_COUNTRY_PLACEHOLDER: '選擇國家',
  RULES_AGREEMENT: '我已閱讀比賽規章並接受其中所述的所有規則。',
  CATEGORY_WARNING:
    '如果你之前曾獲獎，請選擇更高的類別。若不遵守規則，可能會被取消資格。',
  MAINTAINERS_LIMIT_REACHED: '已達陪同者人數上限。',
  STUDENT_TABLE_REGISTER_NOTICE: '請務必在個人帳號中為使用者報名比賽',
  COMPANION_REGISTRATION_REQUIRED: '購買前必須先報名比賽',
  MAINTAINERS_ONE_PURCHASE: '1 位陪同者 / 購買',
  MAINTAINERS_OTHER_PURCHASE: '{count} 位陪同者 / 購買',
  OFFICIAL_MODE: '啟用官方 PAMA 題目',
  NUMBERS_TITLE: '記憶數字',
  LENGTH_WORD: '長度',
  DIGITS_SHORT: '位',
  PROGRESS_WORD: '進度',
  WRITE_ANSWER_INTERMEDIATE: '寫下你的答案！下一個數字在...',
  WRITE_ANSWER: '寫下你的答案！',
  PAUSE: '暫停',
  CHECK_ANSWERS: '檢查你的答案。',
  STAGE_FINISHED: '階段完成！',
  NUMBER_WORD: '數字',
  buy_books: '購買教科書',
  CHAMPION_OF_CHAMPIONS: '總冠軍',
  // new
  MAINTAINERS_REGISTRATION_FORM: '陪同者報名表',
  REGISTER_MAINTAINERS: '報名陪同者',
  HIDE_MAINTAINERS_FORM: '隱藏陪同者報名表',
  MAINTAINERS_SUCCESS_SAVED: '陪同者已成功報名',
  PHOTO_LINK_MAINTAINER: '陪同者照片連結',
  RELATION: '身份',
  RELATION_PARENT: '家長',

  RELATION_TEACHER: '教師',
  MAINTAINERS_FILL_ALL_FIELDS: '請至少為一位陪同者填寫所有必填欄位',
  MAINTAINERS: '陪同者',
  MAINTAINERS_LOADED_COUNT: '已載入陪同者：{count}',
  UNFILLED_MAINTAINERS: '未報名陪同者',
  EDIT_MAINTAINER: '編輯陪同者',
  CONFIRM_DELETE_MAINTAINER:
    '您確定要刪除此陪同者嗎？該參賽者的陪同者票券數量將減少 1。',
  FULL_NAME_EN: '英文姓名',
  DONT_SHOW_AGAIN: '不再顯示',
  PRINT_ALL_STAGES: '一次列印所有階段',
};
